/**
 * @license
 * @qwik.dev/core 2.0.0-beta.35-dev+ec37e1e
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as he, isBrowser as de } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as ae } from "@qwik.dev/core/preloader";

const pe = !1;

const ye = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const me = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const we = (t, n, e, s, o = !1) => {
    const r = me(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const be = (t, n, e) => {
    const s = me(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const ve = (t, n, e) => me(t, n, e) >= 0;

const _e = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const ge = t => typeof t === "object" && t !== null;

const Ee = t => Array.isArray(t);

const Se = t => typeof t === "string";

const ke = t => typeof t === "function";

const Re = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = ye(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Pe = "<sync>";

const Te = t => typeof t === "function" && typeof t.getSymbol === "function";

const Rh = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const qe = "q:type";

const Ae = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Ie = 124;

const Ne = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Ce = "q:renderFn";

const Oe = "q:targetEl";

const je = "⚡️";

const Le = "q:slot";

const Fe = "q:s";

const Xe = "[q\\:patch]";

const Ph = "q:r";

const Th = "q:rp";

const De = "q:style";

const We = "style[q\\:style]";

const Ve = We + ",style[q\\:sstyle]";

const Ue = "q:sstyle";

const ze = "q:ctx";

const Be = "q:brefs";

const He = (t, n) => t["qFuncs_" + n] || [];

const Je = "q:base";

const Qe = "q:container-island";

const Ye = "/" + Qe;

const Ge = "q:ignore";

const Ke = "/" + Ge;

const Ze = "q:container";

const ts = "/" + Ze;

const ns = "q:template";

const es = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const ss = "http://www.w3.org/1999/xhtml";

const rs = "http://www.w3.org/2000/svg";

const is = "http://www.w3.org/1998/Math/MathML";

const os = "qRender";

const ls = "q:id";

const us = "q:key";

const cs = "q:props";

const fs = "q:seq";

const as = "q:seqIdx";

const hs = "q:p";

const ds = "q:ps";

const $s = ":on";

const ys = ":onIdx";

const ms = ":onFlags";

const ws = "q:cursorBoundary";

const bs = ":nearestCursorBoundary";

const vs = ":";

const _s = "dangerouslySetInnerHTML";

const Es = 100;

const Ss = t => !!t && typeof t == "object" && typeof t.then === "function";

const ks = (t, n, e) => {
    try {
        const s = t();
        return Ss(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Rs = (t, n) => Ss(t) ? t.then(n) : n(t);

const Ps = t => {
    throw t;
};

function n(t, n = Ps) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Ss(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Es;
    const r = async e => {
        for (;Ss(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Ss(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const Ts = t => je + t;

const qs = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + Ts(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const As = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Ms(t.slice(s, -1));
        }
    }
    return null;
}

const Ms = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = xs(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const xs = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Is = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const Ns = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Cs = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Os = t => {
    if (!t) {
        return "";
    }
    if (Se(t)) {
        return t.trim();
    }
    const n = [];
    if (Ee(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Os(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const js = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function s(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Os(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (Ee(t)) {
                    throw Re(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(js(e) + ":" + Ls(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Ls = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Ns.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Fs = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Xs = () => ({
    isServer: he,
    importSymbol(t, n, e) {
        if (he) {
            const t = Rh(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Re(6, [ e ]);
        }
        if (!n) {
            throw Re(14, [ e ]);
        }
        if (!t) {
            throw Re(13, [ n, e ]);
        }
        const s = Ds(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Ds = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Je) ?? s, s);
    return new URL(e, o);
};

let Ws = /*#__PURE__ */ Xs();

const Vs = t => Ws = t;

const Us = () => Ws;

const qh = () => Ws.isServer;

const Mh = typeof document !== "undefined";

const zs = !he && Mh;

const Bs = zs ? document : void 0;

const Hs = zs && Bs.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const Js = /\.[mc]?js$/;

const Qs = 1e3 / 60;

const Ys = t => {
    let n = Gs.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Dt: t,
            Ct: Js.test(t) ? 0 : 3,
            Wt: n,
            Vt: 1,
            Ut: performance.now(),
            zt: 0,
            Bt: 0
        }))(t, e);
        Gs.set(t, n);
    }
    return n;
};

const Gs = new Map;

let Ks = 0;

const Zs = [];

const tr = Fs(function Ah() {
    er = !1;
    if (!Zs.length) {
        return;
    }
    const t = performance.now() + Qs;
    let n = !1;
    for (;Zs.length; ) {
        const e = Zs[0];
        const s = e.Vt;
        const o = 1 - s;
        if (!(o >= .99 || Ks < 25)) {
            break;
        }
        Zs.shift();
        lr(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Zs.length && !er) {
        er = !0;
        tr();
    }
});

const nr = Fs(r);

let er = !1;

let sr = !1;

let rr = !1;

const ir = [];

const or = () => {
    const t = ir[ir.length - 1];
    const n = t.Ht;
    if (t.Wt) {
        const e = t.Jt;
        if (e >= t.Wt.length) {
            ir.pop();
            return !1;
        }
        const s = t.Wt[e];
        t.Jt = e + 1;
        const o = Ys(s.Dt);
        if (o.Vt === 0) {
            return !0;
        }
        const r = 1 - n.Vt;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Qt);
        } else {
            const t = 1 - s.Qt * r;
            const n = s.Yt;
            const e = t / n;
            i = Math.max(.02, o.Vt * e);
            s.Yt = e;
        }
        ir.push({
            Ht: o,
            Vt: i,
            Gt: t.Gt
        });
        return !0;
    }
    if (t.Gt?.has(n)) {
        ir.pop();
        return !1;
    }
    const e = n.Vt;
    n.Vt = t.Vt;
    if (e - n.Vt < .01) {
        ir.pop();
        return !1;
    }
    if (n.Wt?.length) {
        const e = t.Gt || new Set;
        e.add(n);
        t.Gt = e;
        t.Wt = n.Wt;
        t.Jt = 0;
        return !1;
    }
    ir.pop();
    return !1;
};

function r() {
    if (rr || !ir.length) {
        return;
    }
    sr = !1;
    rr = !0;
    const t = zs ? performance.now() + Qs : 0;
    let n = !1;
    for (;ir.length; ) {
        n = !0;
        const e = or();
        if (zs && e && performance.now() >= t) {
            if (!sr) {
                sr = !0;
                nr();
            }
            break;
        }
    }
    rr = !1;
    n && zs && tr();
}

const lr = t => {
    if (t.Ct >= 2) {
        return;
    }
    Ks++;
    const n = performance.now();
    t.zt = n - t.Ut;
    t.Ct = 2;
    const e = Bs.createElement("link");
    e.href = new URL("undefined" + t.Dt, Bs.baseURI).toString();
    e.rel = Hs;
    e.as = "script";
    e.onload = e.onerror = () => {
        Ks--;
        const s = performance.now();
        t.Bt = s - n;
        t.Ct = 4;
        e.remove();
        tr();
    };
    Bs.head.appendChild(e);
};

const ur = (t, n) => {
    const e = Ys(t);
    e && ((t, n) => {
        ir.unshift({
            Ht: t,
            Vt: n,
            Gt: void 0
        });
    })(e, n);
};

zs && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    ur(e, 0);
                }
            } else {
                ur(t, 0);
            }
            zs ? nr() : r();
        })(t);
    }
});

const cr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const fr = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    }
});

const ar = '"';

const hr = "[";

const dr = "]";

const pr = ",";

const $r = "2.0.0-beta.35-dev+ec37e1e";

const yr = t => t.nodeType === 1;

const Ih = t => t.Nn;

const mr = Symbol();

class wr {
    [mr]=void 0;
}

const br = t => t === "foreignObject";

const vr = t => t === "svg" || br(t);

const _r = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== vs && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const gr = {
    elementNamespace: ss,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!bl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && br(bl(t));
    let o = ss;
    let r = 0;
    const i = typeof n === "string" || Do(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return vr(t);
        }
        if (Do(t)) {
            return vr(bl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = rs;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return _r(t);
        }
        if (Do(t)) {
            return _r(bl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = is;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? rs : e ? is : ss;
        r = t.flags & 1536;
    }
    gr.elementNamespace = o;
    gr.elementNamespaceFlag = r;
    return gr;
}

class Er {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [mr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Sr extends Er {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class kr extends Sr {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Rr extends Er {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Pr = [];

const Tr = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Pr.length;
    for (let t = 0; t < Pr.length; t++) {
        const n = y(Pr[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Pr.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Pr.length; t++) {
        const n = Pr[t];
        let e = !1;
        for (let t = 0; t < Tr.length; t++) {
            const s = Tr[t];
            if (Dl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    Tr.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    if (!(t.flags & 256)) {
        return;
    }
    d(t, n);
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Pr.indexOf(t);
    if (s !== -1) {
        Pr.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = Tr.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = Tr.length - 1;
    e !== s && (Tr[e] = Tr[s]);
    Tr.pop();
    n.o--;
    return !0;
}

const qr = new WeakMap;

const Ar = ":nodeProps";

const Mr = ":nodeDiff";

const xr = ":errorData";

const Ir = ":signal";

function p(t, n, e) {
    n.position = e;
    e && on(e) && function s(t, n, e) {
        h(e, t);
        const s = y(e);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return qr.get(t) ?? null;
}

const Nr = Symbol();

class Cr {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Or = Symbol();

const jr = Symbol();

const Lr = Symbol();

function m(t, n, e) {
    t[mr] || (he && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Be, new Map) : t[mr] = new Map);
    const o = t[mr];
    let r = o.get(n);
    if (!r) {
        r = new Cr(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Fr = (t, n) => (e, s) => {
    const o = ce();
    o.Lt = m(t, ":");
    o.$ = n || void 0;
    return oe(o, () => {
        if (ke(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (nu(e)) {
            return e.value;
        }
        if (ge(e) && yu(e)) {
            Rn(hu(e), Lr, au(e), o.Lt);
            return e;
        }
        throw Re(2);
    });
};

class Xr {
    Kt;
    ut=void 0;
    $=null;
    Zt=null;
    constructor(t, n) {
        this.$ = t || of()?.$ || null;
        this.Kt = n;
    }
    trigger() {
        ou(this.$, this, this.ut);
    }
    force() {
        ou(this.$, this, this.ut);
    }
    get untrackedValue() {
        return this.Kt;
    }
    set untrackedValue(t) {
        this.Kt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = of();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Lt;
        if (e) {
            const t = he;
            const s = this.ut ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            eu(s, e);
            su(e, this);
            if (t) {
                const t = iu(n.$, this.$);
                o && t?.tn?.(this, e, null);
                ru(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Kt) {
            this.Kt = t;
            ou(this.$, this, this.ut);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Kt
        };
    }
}

class Dr extends Xr {
    nn;
    h;
    [mr]=void 0;
    constructor(t, n, e = 17) {
        super(t || of()?.$, Nr);
        this.nn = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = ce();
        t.$ = this.$ || void 0;
        const e = n(le.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Kt;
    }
    set untrackedValue(t) {
        this.Kt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.nn;
        tu(t);
        const n = of();
        const e = n?.Lt;
        if (n) {
            const t = m(this, ".");
            bn(this.$, t);
            n.Lt = t;
        }
        try {
            const e = t.getFn(n)();
            if (Ss(e)) {
                throw Re(29, [ t.dev ? t.dev.file : "", t.it ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Lt = e);
        }
    }
}

class Wr {
    en;
    sn=null;
    rn=!1;
    ln=!0;
    constructor(t, n, e) {
        this.en = t;
        if (n !== void 0) {
            this.info = n;
            this.un = e;
        }
    }
    get track() {
        return this.cn ||= Fr(this.en, this.en.$);
    }
    get abortSignal() {
        return (this.fn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.en.Kt;
        if (t !== Nr) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.an ||= []).push(t);
    }
}

class Vr extends Dr {
    hn=!1;
    dn=void 0;
    pn=null;
    [mr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Kt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.$n = r;
            this.yn = [];
        }
        const i = s.timeout;
        i && (this.mn = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.pn?.sn) {
            if (this.Kt === Nr || he) {
                throw this.pn?.sn;
            }
            return this.Kt;
        }
        if (this.dn) {
            throw this.dn;
        }
        if (he && this.h & 64 && this.Kt === Nr) {
            throw Re(35);
        }
        return this.Kt;
    }
    set untrackedValue(t) {
        this.Kt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.wn = void 0;
        if (this.yn) {
            for (let t = 0; t < this.yn.length; t++) {
                this.yn[t].ln = !1;
            }
        } else {
            this.pn && (this.pn.ln = !1);
        }
        this.bn();
        super.value = t;
        this.vn();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = of();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Lt;
            if (t) {
                eu(this.dt ||= new Set, t);
                su(t, this);
                ru(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.hn) {
            this.hn = t;
            ou(this.$, this, this.dt);
        }
    }
    get untrackedLoading() {
        this.p();
        if (he && this.pn?.sn) {
            throw this.pn?.sn;
        }
        return this.hn;
    }
    get error() {
        const t = this.untrackedError;
        const n = of();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Lt;
            if (t) {
                eu(this.$t ||= new Set, t);
                su(t, this);
                ru(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.dn) {
            this.dn = t;
            ou(this.$, this, this.$t);
        }
    }
    get untrackedError() {
        return this.dn;
    }
    get expires() {
        return this.Rt || 0;
    }
    set expires(t) {
        this.bn();
        this.Rt = t;
        this.Rt && this._n() && this.vn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Rt && this._n()) {
            this.bn();
            this.vn();
        }
    }
    get interval() {
        const t = this.Rt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.wn = t;
            this.un = this.un === void 0 ? 1 : this.un + 1;
        }
        this.gn(!0, this.h & 128);
    }
    gn(t, n) {
        this.h |= 1;
        this.bn();
        n && (this.Kt = Nr);
        t && (this.ut?.size || this.dt?.size || this.$t?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.pn && this.En(this.pn, t);
    }
    yt() {
        if (!(this.h & 32) || this._n()) {
            return;
        }
        if (!de) {
            return;
        }
        setTimeout(() => {
            this._n() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.pn?.sn; ) {
            await (this.pn?.sn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (he && this.h & 64) {
            this.hn = !0;
            this.$?.serializationCtx.Pt.add(this);
            return;
        }
        this.bn();
        this.h &= -2;
        const t = this.pn;
        t && this.En(t);
        const n = this.$n === 0 ? Infinity : this.$n ?? 1;
        if (this.yn ? this.yn.length >= n : t?.sn) {
            this.h |= 1;
            return;
        }
        const e = this.un;
        const s = new Wr(this, this.wn, e);
        this.pn = s;
        this.yn && this.yn.push(s);
        s.sn = this.Sn(s);
    }
    async Sn(t) {
        let e = this.nn.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.nn.resolve();
            if (t.fn?.signal.aborted) {
                t.sn = null;
                return;
            }
        }
        try {
            this.mn && (this.kn = setTimeout(() => {
                const n = Error(`timeout ${this.mn}ms`);
                this.Rn(t, n);
                t.fn?.abort(n);
            }, this.mn));
            const s = n(e.bind(null, t));
            let o;
            if (Ss(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.sn = null;
            if (t.ln) {
                const n = this.yn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].ln = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.sn = null;
            this.Rn(t, n);
        }
        if ((() => t === this.pn)()) {
            clearTimeout(this.kn);
            t.un === this.un && (this.wn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this.vn();
            }
        }
    }
    Rn(t, n) {
        if (t !== this.pn || !t.ln) {
            return;
        }
        t.ln = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Nr;
    }
    async Pn() {
        this.bn();
        clearTimeout(this.kn);
        const t = this.pn;
        t && this.En(t);
        this.yn ? await Promise.all(this.yn.map(t => t.sn)) : await (t?.sn);
    }
    bn() {
        if (this.Tn !== void 0) {
            clearTimeout(this.Tn);
            this.Tn = void 0;
        }
    }
    vn() {
        if (he || !this.Rt) {
            return;
        }
        this.bn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.Tn = setTimeout(() => this.gn(t, n), this.Rt);
        this.Tn?.unref?.();
    }
    _n() {
        return !!(this.ut?.size || this.dt?.size || this.$t?.size);
    }
    En(t, n) {
        if (t.rn) {
            return;
        }
        t.rn = !0;
        t.fn?.abort(n);
        t.sn = Rs(t.sn, () => this.qn(t));
    }
    qn(t) {
        const n = t.an;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.sn = null;
            n && (n.length = 0);
            const e = this.yn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    Ss(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const Ur = Symbol();

const zr = Symbol();

const Br = Symbol();

const Hr = Symbol();

const Jr = Symbol();

const Qr = Symbol();

const Yr = [];

const Gr = {};

Object.freeze(Yr);

Object.freeze(Gr);

function w(t) {
    return new Proxy({}, new Kr(t));
}

class Kr {
    owner;
    ut=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Ur) {
            return this.owner.constProps;
        }
        if (n === zr) {
            return this.owner.varProps;
        }
        if (n === Br) {
            return this.owner;
        }
        if (n === Hr) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = ni(this.owner, n);
            n in this.owner.varProps && Zr(this, n);
        }
        return s instanceof _i && s.h & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === Br) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === Ur) {
            this.owner.constProps = s;
        } else if (n === zr) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Gr ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                ti(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ti(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Ur || n === zr) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Zr(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Zr = (t, n) => {
    const e = of();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Lt;
    s && Rn(t.owner._proxy, n, t, s);
};

const ti = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ut, n);
    e && ou(t.$, t, e);
    return !!e;
};

const ni = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const ei = (t, n) => si(t)?.[n] || ri(t)?.[n] || null;

const si = t => {
    if (!t) {
        return null;
    }
    return zr in t ? "children" in t ? {
        ...t[zr],
        children: t.children
    } : t[zr] : t;
};

const ri = t => {
    if (!t) {
        return null;
    }
    return Ur in t ? t[Ur] : null;
};

const ii = t => t && zr in t;

const oi = t => (n, ...e) => t.call(null, Df(n), ...e);

class li extends Dr {
    constructor(t, n) {
        super(t, n, 17);
    }
    An=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        tu(this.nn);
        const t = ff(this.nn.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Kt === Nr ? e : this.Kt;
        const r = hf(() => this.An ? s?.(o) || o : n(o), this, ".", this.$);
        this.An = !0;
        this.h &= -2;
        const i = this.An && r !== "undefined" || r !== this.Kt;
        if (i) {
            this.Kt = r;
            ou(this.$, this, this.ut);
        }
    }
}

const ui = (t, n) => new Dr(n?.container || null, t, uu(n?.serializationStrategy || "always"));

const ci = (t, n) => new Vr(n?.container || null, t, uu(n?.serializationStrategy || "always"), n);

const fi = t => new li(null, t);

const ai = t => new Xr(null, t);

const hi = /*#__PURE__*/ oi(ui);

const di = /*#__PURE__*/ oi(ci);

const pi = oi(fi);

const $i = t => t.value;

const yi = (t, n) => t[n];

const mi = t => {
    if (t.length === 1) {
        if (nu(t[0])) {
            return t[0].Zt ||= new _i(null, $i, t, null);
        }
        if (yu(t[0])) {
            return new _i(null, $i, t, null);
        }
        return t[0].value;
    }
    return new _i(null, yi, t, null);
};

const wi = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!ge(n)) {
        return n[e];
    }
    if (nu(n)) {
        if (n instanceof _i && n.h & 4) {
            return n;
        }
        return mi(t);
    }
    if (ii(n)) {
        const s = n[Ur];
        const o = n[zr];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return bi(n, t);
        }
    } else {
        const s = hu(n);
        if (s) {
            const n = s[e];
            return bi(n, t);
        }
    }
    return n[e];
};

const bi = (t, n) => nu(t) ? t : mi(n);

const vi = (t, n) => {
    const e = wi(t, n);
    if (e === Jr) {
        return t[n];
    }
    return e;
};

class _i extends Xr {
    lt;
    ot;
    St;
    h;
    m=void 0;
    [mr]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Nr);
        this.lt = e;
        this.ot = n;
        this.St = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, Ir, this);
                cn(this.$, this.m, 16);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            ou(this.$, this, this.ut);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Kt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = hf(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Kt;
        if (n) {
            this.h |= 2;
            this.Kt = t;
        }
    }
    rt() {
        return this.ot === $i && nu(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw Re(31);
    }
    get value() {
        return super.value;
    }
}

class gi {
    data;
    constructor(t) {
        this.data = t;
    }
}

const Ei = (t, n) => {
    if (typeof t === "string") {
        const e = te(n);
        Tf(qf(e, t));
    }
    return null;
};

function b(t, n) {
    Ei(this, n);
    const e = Pf[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function v(t, n) {
    Ei(this, n);
    const e = Pf[0];
    e.value = n.checked;
}

function _(t, n) {
    Ei(this, n);
    if (Pf) {
        for (let t = 0; t < Pf.length; t++) {
            const n = Pf[t];
            n instanceof Vr && n.h & 64 && n.p();
        }
    }
}

Object.prototype.hasOwnProperty;

class Si {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || cr(n) ? Gr : n;
        this.constProps = !e || cr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const ki = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Ri = t => t instanceof Si;

const Pi = "bind:value";

const Ti = "bind:checked";

const qi = "passive:";

const Ai = "preventdefault:";

const Mi = Object.prototype.hasOwnProperty;

const xi = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Ms(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Ii = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Ms(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Ms(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Ms(t.slice(11, -1));
    }
    return null;
};

const Ni = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = Ii(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const Ci = (t, n, e, s, o, r, i) => new Si(t, n, e, s, o, r, !1, i);

const Oi = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(qi)) {
                    r.push(o);
                    t.add(Ms(o.slice(8)));
                } else {
                    o.startsWith(Ai) ? h.push(o) : Ii(o) !== null ? s.push(o) : o === Ti ? a = e[o] : o === Pi && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(qi)) {
                    i.push(s);
                    t.add(Ms(s.slice(8)));
                } else {
                    s.startsWith(Ai) ? d.push(s) : Ii(s) !== null ? o.push(s) : s === Ti ? a = n[s] : s === Pi && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = xi(e, r, h, t, l);
            l = l || e !== n;
            e = Ni(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = xi(n, i, d, t, u);
            u = u || n !== e;
            n = Ni(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Mi.call(n, Ti) && delete n[Ti];
                if (e && Mi.call(e, Ti)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Ti];
                }
                n.checked = a;
                const t = If(null, "_chk", v, null, [ a ]);
                if (e && Mi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = ki(n, "q-e:input", t) || c;
                }
                c = ki(n, "q-e:input", t) || c;
            } else if (f) {
                n && Mi.call(n, Pi) && delete n[Pi];
                if (e && Mi.call(e, Pi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Pi];
                }
                n.value = f;
                const t = If(null, "_val", b, null, [ f ]);
                if (e && Mi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = ki(n, "q-e:input", t) || c;
                }
                c = ki(n, "q-e:input", t) || c;
            }
        }
        if (n && Mi.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Mi.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Si(t, n, e, s, o, r, c || !0, i);
};

const ji = (t, n, e, s) => Di(t, n, s);

const Li = (t, n, e, s, o) => Di(t, {
    ...e,
    ...n
}, o);

const Fi = (t, n, e, s, o, r) => Di(t, {
    ...e,
    ...n,
    children: s
}, r);

const Xi = t => t.children;

const Di = (t, n, e, s, o) => Oi(t, n, null, null, 0, e, o);

const Wi = Di;

const Vi = Di;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Oi(t, n, null, s.children, 0, o);
}

const Ui = t => t.children;

const zi = (t, n) => new Si(Xi, null, null, t.children, 0, n);

const Bi = (t, n, e, s, o) => {
    const r = ue(t.Ot, e || n, t);
    if (e) {
        r.Lt = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Ce));
    if (Te(s)) {
        o = o || t.getHostProp(n, cs) || Gr;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Qf(s)) {
        const t = s;
        i = () => le(r, t, [ o || Gr, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => le(r, t, [ o || Gr ]);
    }
    const l = he;
    const u = (e = 0) => ks(() => {
        if (!c) {
            t.setHostProp(n, as, null);
            t.setHostProp(n, ys, null);
        }
        e > 0 && Xo(n) && wn(t, n);
        return Rs(i(o), t => Rs(r.Ft, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Es) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, $s);
        if (o) {
            return function r(t, n) {
                const e = R(t);
                let s = t;
                const o = "q-e:qvisible";
                return Rs(e, t => {
                    const e = !t;
                    let r = null;
                    for (const i in n) {
                        if (Object.prototype.hasOwnProperty.call(n, i)) {
                            let c = t;
                            let l = i;
                            if (e) {
                                if (i !== o && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    const [t, n] = P(s);
                                    s = n;
                                    r = t;
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === o && (l = "q-d:qinit");
                                S(c, l, n[i]);
                            }
                        }
                    }
                    return s;
                });
            }(s, o);
        }
        return s;
    }, t => {
        if (Ss(t) && e < Es) {
            return t.then(() => u(++e));
        }
        if (e >= Es) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function S(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Is(n);
    c && k(t, f, "capture");
    l && k(t, f, "preventdefault");
    u && k(t, f, "stoppropagation");
}

function k(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Gr && (t.varProps = {});
    t.varProps[s] = !0;
}

function R(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Ri(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Ee(t)) {
            n.push(...t);
        } else {
            if (Ss(t)) {
                return Rs(t, t => R(t));
            }
            if (nu(t)) {
                return R(t.untrackedValue);
            }
        }
    }
    return null;
}

function P(t) {
    if (Ri(t)) {
        const n = T();
        if (t.type !== Ui && !Qf(t.type)) {
            return [ n, Ci(Ui, null, null, [ t, n ], 0, null) ];
        }
        t.children == null ? t.children = n : Ee(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return [ n, t ];
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        const n = T();
        return [ n, Ci(Ui, null, null, [ t, n ], 0, null) ];
    }
    if (Ee(t) && t.length > 0) {
        const [n, e] = P(t[0]);
        return [ n, t ];
    }
    return [ null, t ];
}

function T() {
    return new Si("script", null, {
        hidden: ""
    }, null, 0, null);
}

const Hi = t => Ci(Xi, null, {
    [Fe]: ""
}, t.children, 0, t.name ?? "");

const Ji = Symbol();

const Qi = () => null;

const Yi = () => null;

const Gi = t => t.children;

const Ki = (t, n) => Di(zi, {
    children: Di(Zi, t)
}, n);

const Zi = () => null;

let to = null;

let no = null;

function q(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    no || (no = t.setAttributeNS);
                    no.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            to || (to = t.setAttribute);
            to.call(t, n, e);
        })(t, n, e);
    }
}

const eo = Object.prototype.hasOwnProperty;

function A(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const so = (t, n = [], e = {}) => {
    let s = null;
    const o = t[Ur];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[zr];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new Si(null, r, s, null, 0, null));
};

function M(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && eo.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof _i) {
            return df(n, t, ":", e);
        }
    }
    return ni(n, "name") || "";
}

class ro {
    target;
    constructor(t) {
        this.target = t;
    }
}

class io {
    target;
    constructor(t) {
        this.target = t;
    }
}

class oo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class lo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class uo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const co = t => new ro(t);

const fo = t => new io(t);

const ao = (t, n) => new oo(t, n);

const ho = (t, n, e) => new lo(t, n, e);

const po = (t, n, e, s = null, o = !1) => new uo(t, n, e, s, o);

const $o = () => {
    const t = uf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, fs);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, fs, s);
    }
    let o = t.$.getHostProp(e, as);
    o === null && (o = 0);
    t.$.setHostProp(e, as, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const yo = t => {
    const n = ke(t) && !Qf(t) ? oe(void 0, t) : t;
    return ai(n);
};

const mo = t => wo(yo, t);

const wo = (t, ...n) => {
    const {val: e, set: s} = $o();
    if (e != null) {
        return e;
    }
    t = ke(t) && !Qf(t) ? ff(t, ...n) : t;
    return s(t);
};

const bo = () => ({
    pending: ai(0),
    version: ai(0)
});

function x(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = C(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function I(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, ws);
}

function N(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    Jo(t, bs, null);
}

function C(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return Ho(t, bs, null) || null;
    }(n) || I(t, n);
}

function O(t, n) {
    __EXPERIMENTAL__.suspense && Jo(t, bs, n);
}

function j(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    O(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        j(t, o, I(t, o) || e);
    }
}

const vo = t => {
    if (t.Pn) {
        try {
            t.Pn();
        } catch (t) {
            ((t, ...n) => {
                ye(!1, t, ...n);
            })(t);
        }
        t.Pn = null;
    }
};

function L(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = cf(e, s));
    const r = o.$;
    const i = o.m;
    Go(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = Ho(i, hs, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Ho(i, ds, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return le(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function F(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = cf(t, n);
    typeof this === "string" && Tf(qf(e.$, this));
    const s = Pf[0];
    return L(s, t, n, e);
}

function X(t) {
    return t.k === t.R ? t.T : null;
}

function D(t) {
    return t.q || X(t);
}

function W(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = X(t);
    return e === o ? null : e;
}

const _o = Object.prototype.hasOwnProperty;

function V(t, n, e, s, o, r) {
    Jo(n, e, r);
    fn(t, po(n.node, e, s, o, (n.flags & 512) !== 0));
}

function U(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        X: [],
        k: null,
        q: null,
        D: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new gi({
                O: s,
                et: !0
            }),
            st: new gi({
                O: s,
                et: !1
            })
        }
    };
}

function z(t, n, e, s, o) {
    const r = t ?? U(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.st.data.O = o;
        t.L.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const go = (t, n, e, s, o, r, i) => B(z(i, t, n, o, r), e, s);

const Eo = (t, n, e, s, o, r, i, c, l = !1, u) => B(z(u, t, n, i, c), e, s, o, r, l);

function B(t, n, e, s = gl(e), o = null, r = !1) {
    H(t, n, e, s, o, r);
    const i = st(t);
    if (Ss(i)) {
        return i.finally(() => {
            rt(t);
        });
    }
    rt(t);
}

function H(t, n, e, s = gl(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.D = null;
    t.q = s;
    t.T = o;
    t.R = e;
    K(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    Et(t, t.J);
                } else if (typeof t.J === "number") {
                    Et(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (Ri(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            lt(t);
                            $t(t, t.J, n);
                            const e = t.J.constProps && _o.call(t.J.constProps, _s) || _o.call(t.J.varProps, _s);
                            e ? t.D || it(t, !1) : Y(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Ui) {
                                lt(t);
                                bt(t, "F", t.J.key);
                                Y(t, t.J.children, !0);
                            } else if (n === Hi) {
                                lt(t);
                                nt(t) || Y(t, t.J.children, !0);
                            } else if (n === Rt) {
                                tt(t);
                                Y(t, t.J.children, !0, !1);
                            } else if (n === Yi) {
                                ot(t);
                            } else if (n === Qi) {
                                ot(t);
                            } else {
                                lt(t);
                                vt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        Y(t, t.J, !1);
                    } else if (nu(t.J)) {
                        bt(t, "S", null);
                        const n = t.J instanceof _i ? t.J.rt() : t.J;
                        const e = t.q?.[mr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof _i && (s = It(e, n));
                        if (!s) {
                            const e = t.D || t.q;
                            Y(t, J(t, () => df(n, e, ".", t.$)), !0);
                        }
                    } else if (Ss(t.J)) {
                        bt(t, "A", null);
                        t.L.push(t.J, t.D || t.q);
                    }
                } else {
                    t.J === Ji || Et(t, "");
                }
                Q(t);
            }
            ot(t);
            et(t);
            G(t);
        }
    } finally {
        t.Z = i;
    }
}

function J(t, e) {
    try {
        return e();
    } catch (s) {
        if (Ss(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.D || t.q);
            return null;
        }
        throw s;
    }
}

function Q(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return G(t);
    }
    t.D !== null ? t.D = null : t.q = W(t, t.q);
}

function Y(t, n, e, s = !0) {
    if (s && (n == null || e && Ee(n) && n.length === 0)) {
        it(t);
        return;
    }
    K(t, n, e);
    if (e) {
        const n = t.Z || !!t.D || !gl(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.D || t.q;
        t.q = gl(t.k);
        t.D = null;
    }
    t.K = !1;
}

function G(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.D = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    Q(t);
}

function K(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.D, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function Z(t) {
    if (t.D) {
        return D(t);
    }
    return W(t, t.q) || X(t);
}

function tt(t) {
    const n = t.J;
    const e = n.key;
    t.q = Ho(t.k, e, n => nl(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.D = Fo();
        Jo(t.D, Le, e);
        t.D.slotParent = t.k;
        Jo(t.k, e, t.D);
    }
}

function nt(t) {
    const n = t.J;
    const e = Ql(t.k);
    const s = M(e, n, t.$);
    const o = ni(n, ws) || null;
    const r = e ? Ho(e, s, null) : null;
    if (r == null) {
        t.D = Fo();
        Jo(t.D, Le, s);
        Jo(t.D, ws, o);
        j(t.$, t.D, o);
        e && Jo(e, s, t.D);
        pl(t.M, t.k, t.D, Z(t));
        return !1;
    }
    if (r === t.q) {} else {
        const n = r.parent;
        t.D = r;
        Jo(t.D, Le, s);
        Jo(t.D, ws, o);
        j(t.$, t.D, o);
        e && Jo(e, s, t.D);
        dl(t.M, t.D);
        pl(t.M, t.k, t.D, Z(t));
        n && Do(n) && !n.firstChild && bl(n) === ns && ml(t.M, n.parent, n, !0);
    }
    return !0;
}

function et(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            qt(t.$, t.M, e, t.N);
            ml(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function st(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (Ss(n)) {
            return n.then(n => {
                H(t, n, e);
                return st(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return st(t);
            });
        }
        H(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => st(t));
    }
}

function rt(t) {
    t.M = null;
    t.N = null;
}

function it(t, n = !0) {
    const e = t.q && gl(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            qt(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        wl(t.M, t.q, e, n);
    }
}

function ot(t) {
    const n = X(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = W(t, t.q);
            if (t.k === n.parent) {
                qt(t.$, t.M, n, t.N);
                ml(t.M, t.k, n, !0);
            }
        }
    }
}

function lt(t) {
    if (t.q !== null && Uo(t.q)) {
        const n = t.q;
        t.q = W(t, t.q);
        ml(t.M, t.k, n, !0);
    }
}

function ut(t, n, e) {
    if (nu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Re(15, [ e ]);
}

function ct(t, e, s, o, r) {
    return n(() => df(o, e, s, t, r));
}

function ft(t, n, e, o, r) {
    const i = t.O;
    const c = o.then(t => q(n, e, s(e, t, i), r));
    t.X.push(c);
}

function at(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Ze, "html");
    }
}

function ht(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function dt(t, n, e, r) {
    const i = function c(t, n) {
        const e = yl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.D = Oo(i, n);
        t.D.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.D;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (As(n)) {
                pt(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && ut(o, i, r)) {
                continue;
            }
            nu(o) && (o = ct(t.$, t.D, n, o, t.tt.nt));
            if (Ss(o)) {
                ft(t, i, n, o, u);
                continue;
            }
            if (n === _s) {
                at(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ht(i, o)) {
                continue;
            }
            q(i, n, s(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.D.key = a);
    if (t.O) {
        const e = _o.call(n.varProps, "class") || n.constProps && _o.call(n.constProps, "class");
        e || i.setAttribute("class", t.O);
    }
    ul(t.M, t.k, t.D, D(t));
}

function pt(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(L.bind(null, n));
                }
            } else {
                e && s.push(L.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = L.bind(null, n));
    }
    t.charAt(2) !== "e" && Qo(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function $t(t, n, e) {
    if (t.Z) {
        dt(t, n, e, null);
    } else {
        const s = t.q && Do(t.q);
        const o = s && e === bl(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            mt(t, e, r);
        } else {
            const s = yt(e, r);
            wt(t, e, r, s, t.k) && dt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.D || t.q;
    s && function r(t, n, e, s) {
        t.Z || Go(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && _o.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof _i && e instanceof _i && xt(i, e)) {
                        continue;
                    }
                    So(t, n, r, i, s);
                }
            } else {
                i != null && So(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                _o.call(e, r) || r.charAt(0) === ":" || As(r) || So(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const So = (t, n, e, s, o) => {
    if (As(e)) {
        pt(e, s, n.node, n, t);
        return;
    }
    if (e === hs || e === ds) {
        Jo(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (ut(s, t, o)) {
            return;
        }
    }
    const i = n[mr]?.get(e);
    if (nu(s)) {
        const o = s instanceof _i ? s.rt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && bn(t.$, i);
        const r = n;
        s = ct(t.$, r, e, o, t.tt.st);
    } else {
        i && bn(t.$, i);
    }
    if (Ss(s)) {
        const o = n;
        const i = s.then(n => {
            V(t.M, o, e, n, t.O, r);
        });
        t.X.push(i);
        return;
    }
    V(t.M, n, e, s, t.O, r);
};

function yt(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function mt(t, n, e) {
    const s = yt(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function wt(t, n, e, s, o, r) {
    t.D = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = Do(o) ? bl(o) : null;
                const r = St(o) || kt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = X(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = Do(i) ? bl(i) : null;
                const r = St(i) || kt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(yt(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = yt(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = Do(t.q) ? bl(t.q) : null;
                    const e = St(t.q) || kt(t.q, t.$._);
                    if (e != null) {
                        const s = yt(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = X(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = Do(s) ? bl(s) : null;
                const e = St(s) || kt(s, t.$._);
                if (e != null) {
                    const o = yt(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.D) {
        s || pl(t.M, o, t.D, D(t));
        t.q = t.D;
        t.D = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = St(t.q) || kt(t.q, t.$._);
                if (n != null) {
                    const e = Do(t.q) ? bl(t.q) : null;
                    const s = yt(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && pl(t.M, o, n, D(t));
            t.q = n;
            t.D = null;
            return !1;
        }
    }
    return !0;
}

function bt(t, n, e) {
    const s = n === "F";
    const o = St(t.q);
    const r = t.q && zo(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        mt(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        cl(t.M, t.k, t.D = Fo(), Z(t));
        t.D.key = e;
        return;
    }
    if (wt(t, null, e, yt(null, e), t.k, !0)) {
        cl(t.M, t.k, t.D = Fo(), Z(t));
        t.D.key = e;
    }
}

function vt(t, n) {
    const e = n[Jf];
    let s = t.D || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.it;
        const l = kt(s, t.$._);
        const u = o.key || c;
        const f = St(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                mt(t, null, u);
            } else {
                _t(t, s, i, n);
                s = t.D;
                r = !0;
            }
        } else {
            if (wt(t, null, u, u, t.k)) {
                _t(t, s, i, n);
                r = !0;
            }
            s = t.D || t.q;
        }
        if (s) {
            const e = Ho(s, cs, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = Pt(n[Ur], e[Ur], e[Hr], s, !1);
                        o ||= t;
                        const r = Pt(n[zr], e[zr], e[Hr], s, !0);
                        o ||= r;
                        e[Br] = n[Br];
                    } else if (n) {
                        Jo(t, cs, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    _t(t, s, i, n);
                    s = t.D;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                Jo(s, Ce, i);
                s.flags &= -33;
                cn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Si(Rt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (A(n)) {
                            const t = n;
                            we(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Ri(n) && ni(n, Le) || "") + "";
                const i = me(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            Y(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = St(s);
        const i = e === r;
        const c = kt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            gt(t);
            s = t.D;
        } else if (i) {
            mt(t, null, e);
        } else {
            wt(t, null, e, e, t.k) && gt(t);
            s = t.D || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!zo(e) || Ho(e, Ce, null) === null); ) {
                e = e.parent || Ql(e);
            }
            const r = Bi(t.$, s, e || t.$.rootVNode, n, o.props);
            t.L.push(r, s);
        }
    }
}

function _t(t, n, e, s) {
    n && wn(t.$, n);
    cl(t.M, t.k, t.D = Fo(), Z(t));
    const o = t.J;
    Jo(t.D, Ce, e);
    Jo(t.D, cs, s);
    t.D.key = o.key;
}

function gt(t) {
    cl(t.M, t.k, t.D = Fo(), Z(t));
    const n = t.J;
    Jo(t.D, cs, n.props);
    n.key && (t.D.key = n.key);
}

function Et(t, n) {
    if (t.q !== null) {
        const e = Hl(t.q);
        if (e === 3) {
            if (n !== vl(t.q)) {
                _l(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    ul(t.M, t.k, t.D = Lo(document.createTextNode(n), n), D(t));
}

function St(t) {
    if (t == null || Uo(t)) {
        return null;
    }
    return t.key;
}

function kt(t, n) {
    if (t == null || Uo(t)) {
        return null;
    }
    const e = Ho(t, Ce, n);
    return e ? e.it : null;
}

function Rt() {}

function Pt(t, n, e, s, o = !0) {
    if (Tt(t) && Tt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Be) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = ti(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Be) {
                continue;
            }
            if ((!t || !_o.call(t, s)) && o) {
                delete n[s];
                const t = ti(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function Tt(t) {
    if (!t) {
        return !0;
    }
    return cr(t);
}

function qt(t, n, e, s = null) {
    let o = e;
    const r = s && on(s) ? y(s) : null;
    if (Uo(e)) {
        Mt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && on(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            wn(t, o);
            Mt(o);
            const r = c & 2 && Ho(o, Ce, null) !== null;
            if (r) {
                const e = t.getHostProp(o, fs);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (ge(r)) {
                            const n = Zl(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                cn(t, o, 64, s);
                                continue;
                            }
                            (r instanceof Xr || yu(r)) && wn(t, r);
                            (n || r instanceof Vr) && vo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (A(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? nl(t.rootVNode, e) : e;
                                let c = gl(o);
                                for (;c; ) {
                                    qt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                At(n, o);
                            }
                        }
                    }
                }
            }
            const i = Bo(o);
            if (i) {
                if (o === e) {
                    const t = gl(o);
                    if (t) {
                        dn(t, t => {
                            t.flags & 2 && t.slotParent;
                        });
                        return;
                    }
                }
            } else {
                const t = gl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Mt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function At(t, n) {
    const e = n.parent;
    if (e) {
        const s = e.flags;
        s & 1 && bl(e) === ns && ml(t, e, n, !0);
    }
}

function Mt(t) {
    t.flags |= 32;
}

function xt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function It(t, n) {
    if (!(n instanceof _i)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof _i && xt(s, n)) {
            return !0;
        }
    }
    return !1;
}

function Nt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Ct(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Nt(t[c], c, r, s);
    }
    return i;
}

function Ot(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function jt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = gl(e);
    const f = U(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Eo(c, n, Ct(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        wl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Eo(c, n, Ct(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        wl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            ml(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return Eo(c, n, Ct(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            ml(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < w; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(w);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let A = m;
    const I = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                A = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || pl(n, e, t, A);
                A = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = Eo(c, n, Ct(o, a, null, i, l, M), e, A, A, s, null, !0, f);
            return Rs(d, () => {
                const t = Ot(e, A, u);
                A = t;
                M = l - 1;
                return I();
            });
        }
    };
    return I();
}

function Lt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, fs);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Kl) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Gl(s, n, t);
                Ss(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ft(t, n) {
    const e = t.props ||= {};
    e[Mr] = n;
}

function Xt(t, n) {
    t.dirty &= -257;
    const e = function s(t) {
        const n = t.props;
        return n?.[xr] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[xr] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = ol(n, document, r, e);
    const u = Do(r) && i || r;
    const f = u === r ? null : c;
    ul(n, u, l, f);
    t.dirty &= -33;
    t.dirtyChildren = null;
}

function Dt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Mr];
    }(t);
    if (!r) {
        return;
    }
    Ft(t, null);
    nu(r) && (r = r.value);
    return go(n, e, r, o, s, null);
}

function Wt(t, e, s, o) {
    t.dirty &= -5;
    const r = t;
    const i = e.getHostProp(r, Ce);
    if (!i) {
        return;
    }
    const c = e.getHostProp(r, cs) || null;
    const l = ks(() => Bi(e, r, r, i, c), t => {
        const i = e.getHostProp(r, Ue);
        return n(() => go(e, s, t, r, o, qs(i)));
    }, t => {
        e.handleError(t, r);
    });
    if (Ss(l)) {
        return l;
    }
    return;
}

function Vt(t, n, e, s, o, r = null) {
    n.push(po(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Ut(t, n) {
    t.dirty &= -9;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Ar] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        nu(e) && (e = e.value);
        const r = s.isConst;
        Vt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Ar];
    })(t);
}

function zt(t, n) {
    t.dirty &= -65;
    const e = n.getHostProp(t, fs);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Kl && n.h & 16) {
            n.h &= -17;
            const t = n;
            vo(t);
        }
    }
}

function Bt(t, e) {
    t.dirty &= -17;
    const s = e.getHostProp(t, Ir);
    if (!s) {
        return;
    }
    const o = s.ut;
    const r = ce();
    r.$ = e;
    return Rs(n(() => oe.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return ou(e, s, o);
        }
    });
}

function Ht(t, n, e, s) {
    t.dirty &= -129;
    const o = t;
    const r = n.getHostProp(o, cs) || null;
    if (!r) {
        return;
    }
    let i = ei(r, "items");
    nu(i) && (i = ff(i));
    const c = ei(r, "key$");
    const l = ei(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return jt(n, e, o, s, i, u, f);
    }
    return Rs(c.resolve(), t => Rs(l.resolve(), r => jt(n, e, o, s, i, t, r)));
}

let ko = null;

const Ro = (t, n, e) => {
    ko || (ko = t.insertBefore);
    ko.call(t, n, e);
};

function Jt(t) {
    let n = null;
    let e = null;
    let o = null;
    const r = new Set;
    const i = () => {
        if (o) {
            if (o.length === 1) {
                Ro(n, o[0], e);
            } else {
                const t = n.ownerDocument || n;
                const s = t.createDocumentFragment();
                for (let t = 0; t < o.length; t++) {
                    s.appendChild(o[t]);
                }
                Ro(n, s, e);
            }
            o = null;
            n = null;
            e = null;
            r.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof lo) {
            if (n === l.parent && e === l.beforeTarget) {
                o || (o = []);
                o.push(l.target);
                r.add(l.target);
                continue;
            }
            if (!o) {
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (r.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            Ro(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof ro) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof io) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof oo) {
            l.target.nodeValue = l.text;
        } else if (l instanceof uo) {
            const t = l.target;
            const e = l.attrName;
            const o = l.attrValue;
            const r = o != null ? s(e, o, l.scopedStyleIdPrefix) : null;
            const c = r == null || r === !1;
            if (Po(t, e)) {
                t[e] = To(r);
            } else if (e === _s) {
                n === t && i();
                t.innerHTML = r;
                t.setAttribute(Ze, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = r : q(t, e, r, l.isSvg);
            }
        }
    }
    i();
}

const Po = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const To = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const qo = (t => () => queueMicrotask(t))(Gt);

const Mo = Fs(Gt);

let xo = !1;

function Qt() {
    if (!xo) {
        xo = !0;
        qo();
    }
}

function Yt() {
    if (!xo) {
        xo = !0;
        Mo();
    }
}

function Gt() {
    xo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (Kt(e, n)) {
            Yt();
            return;
        }
    }
}

function Kt(t, n) {
    const e = he;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        Zt(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 511)) {
            __EXPERIMENTAL__.suspense && N(l);
            p(r, s, en(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 64) {
                zt(l, r);
            } else if (l.dirty & 32) {
                const n = nn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -512;
            p(r, s, en(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Lt(l, r, s);
            } else if (l.dirty & 2) {
                e = Dt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Wt(l, r, i, t);
            } else if (l.dirty & 128) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 8) {
                Ut(l, i);
            } else if (l.dirty & 16) {
                e = Bt(l, r);
            } else if (l.dirty & 32) {
                const n = nn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 256 && Xt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && Ss(e)) {
            x(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                Qt();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    Zt(r, t, s, e);
}

function Zt(t, n, e, s) {
    if (!(n.dirty & 511)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Jt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                let s;
                for (let n = 0; n < e.length; n++) {
                    const o = e[n];
                    const r = Gl(o, t, o.ct);
                    Ss(r) && (s = s ? s.then(() => r) : r);
                }
                s && (n.extraPromises ||= []).push(s);
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                tn(t);
            });
            return;
        }
        tn(t);
    }
}

function tn(t) {
    t.ft();
}

function nn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -33;
        N(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = en(o[0], s, t);
    p(t, n, i);
    return i;
}

function en(t, n, e) {
    if (t === n) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 32 ? s = t.slotParent : t.parent && t.parent.dirty & 32 && (s = t.parent);
    if (!s) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 511) {
            if (e && sn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -33;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && N(s);
    return en(s, n, e);
}

function sn(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(ws in n.props) || !t.getHostProp(n, ws)) {
        return !1;
    }
    on(n) || rn(t, n, 0);
    return !0;
}

function rn(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        qr.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    Qt();
    return r;
}

function on(t) {
    return (t.flags & 256) !== 0;
}

function ln(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 8 && function e(t, n) {
            n.dirty &= -9;
            const e = n.getProp(Ar);
            if (!e || e.size === 0) {
                return;
            }
            for (const [o, r] of e.entries()) {
                let e = r.value;
                nu(e) && (e = e.value);
                const i = s(o, e, r.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, o, i);
            }
        }(t, n);
        n.dirty & 16 && Bt(n, t);
        n.dirty &= -512;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(fs);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Kl) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Gl(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Ss(s) && (e = s);
    }
    if (n.dirty & 128) {
        const s = async function o(t, n) {
            n.dirty &= -129;
            const e = n;
            const s = t.getHostProp(e, cs) || null;
            if (!s) {
                return;
            }
            let o = ei(s, "items");
            nu(o) && (o = ff(o));
            const r = await ei(s, "key$").resolve();
            const i = await ei(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -508;
    if (e) {
        return e;
    }
}

const Io = [];

function un(t) {
    for (let n = 0; n < Io.length; n++) {
        const e = Io[n];
        const s = Io[n + 1] || t;
        s.dirty |= 32;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function cn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return he;
    }()) {
        const e = ln(t, n);
        Ss(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 511;
    if ((i ? o & 511 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            Io.push(n);
            let o = I(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 511;
                const i = on(r);
                __EXPERIMENTAL__.suspense && (o ||= I(t, r) || (e ? C(t, r) : null));
                if (r === s || e) {
                    O(n, o);
                    un(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    Io.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                Io.push(r);
                r = r.slotParent || r.parent;
            }
            Io.length = 0;
            ((t, ...n) => {
                const e = ye(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 511) {
        O(n, I(t, n) || C(t, c));
        i && (c.dirty |= 32);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (on(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        on(n) ? O(n, I(t, n)) : function l(t, n) {
            Io.push(n);
            let e = __EXPERIMENTAL__.suspense ? I(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = on(s);
                __EXPERIMENTAL__.suspense && (e ||= I(t, s) || (o ? C(t, s) : null));
                if (o) {
                    O(n, e);
                    un(s);
                    Io.length = 0;
                    return !0;
                }
                Io.push(s);
                s = s.slotParent || s.parent;
            }
            O(n, e);
            Io.length = 0;
            return !1;
        }(t, n) || rn(t, n, 0);
    }
}

function fn(t, n) {
    t.push(n);
}

const No = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const Co = t => {
    let n = null;
    return e => {
        n || (n = No(e, t));
        return n.call(e);
    };
};

const Oo = (t, n, e = null) => {
    const s = new kr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const jo = t => {
    const n = new kr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const Lo = (t, n) => {
    const e = new Rr(-4084, null, null, null, null, t, n);
    return e;
};

const Fo = () => {
    const t = new Sr(null, -4094, null, null, null, null, null, null);
    return t;
};

const Xo = t => t instanceof Er;

const Do = t => (t.flags & 1) === 1;

const Wo = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Vo = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Uo = t => (t.flags & 4) === 4;

const zo = t => (t.flags & 2) === 2;

const Bo = t => {
    const n = t.flags;
    return (n & 2) === 2 && Ho(t, Le, null) !== null;
};

const xh = t => t;

const Ho = (t, n, e) => {
    if (Do(t) || zo(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const Jo = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const Qo = (t, n, e, s, o = null) => {
    if (Do(n)) {
        Jo(n, e, s);
        fn(t, po(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Yo = t => {
    if (t.key) {
        return;
    }
    const n = Pl(t.node, vs);
    n && (t.key = n);
};

const Go = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (As(c)) {
                an(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== vs && c) {
                if (c.startsWith(Ze)) {
                    const t = i.value;
                    t === "html" ? Jo(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && Jo(e, "value", s.value);
                } else {
                    const t = i.value;
                    Jo(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Ho(e, hs, null) === null && Ho(e, ds, null) === null || (n.flags |= 64);
    }
};

const Ko = t => {
    if (t.bt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Te(n)) {
            return n;
        }
    }
    return t;
};

function an(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Ko(Mn(i[t], e));
        c.push(L.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function hn(t, n, e) {
    let s = gl(n);
    for (;s; ) {
        if (Uo(s)) {
            tl(t, s);
            e(s, n);
        } else {
            Do(s) ? e(s, n) : hn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function dn(t, n) {
    let e = t;
    if (Uo(t)) {
        n?.(t, null);
        return;
    }
    let s = null;
    for (;;) {
        if (n?.(e, s)) {
            return;
        }
        const o = gl(e);
        if (o) {
            e = o;
            continue;
        }
        if (e === t) {
            return;
        }
        const r = e.nextSibling;
        if (r) {
            e = r;
            continue;
        }
        s = e.parent;
        for (;s; ) {
            if (s === t) {
                return;
            }
            const n = s.nextSibling;
            if (n) {
                e = n;
                break;
            }
            s = s.parent;
        }
        if (s == null) {
            return;
        }
    }
}

const Zo = (t, n, e) => {
    let s = t;
    for (;e && s && zo(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !zo(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !zo(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Uo(t) && e && Do(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Vl(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const tl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = $l(n, !0);
        const o = e.node;
        const r = jl(s);
        let i = Zo(n, !1, !0);
        const c = Zo(n, !0, !0);
        const l = o || (c && Do(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Uo(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                fn(t, ho(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Zo(i, !1, !0);
        }
        i = n;
        for (;i && Uo(i); ) {
            const n = Zo(i, !0, !0);
            const e = !n || !Uo(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    fn(t, ao(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    fn(t, ho(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const nl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = jo(i);
            Yo(e);
            t.vNode = e;
            return e;
        }
    }
    if (Xo(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || jo(i);
            Yo(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = rl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = il(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = el(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const el = (t, n) => {
    let e = gl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const sl = [];

const rl = (t, n) => {
    let e = gl(t);
    for (;e && (!(e instanceof kr) || e.node !== n); ) {
        if (zo(e)) {
            const t = e.nextSibling;
            const n = gl(e);
            if (n) {
                t && sl.push(t);
                e = n;
            } else {
                e = t || (sl.length ? sl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || sl.pop();
        }
    }
    for (;sl.length; ) {
        sl.pop();
    }
    return e;
};

const il = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const ol = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = Oo(o, "errored-host");
    if (Wo(e)) {
        pl(t, r, e, null);
    } else {
        const n = [];
        hn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            pl(t, r, n[e], null);
        }
    }
    return r;
};

const ll = Jt;

const ul = (t, n, e, s) => {
    const o = Do(n);
    o && El(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    hl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : $l(n, !1);
    l && !c && fn(t, ho(i, l, fl(t, n, s)?.node ?? null));
    al(n, e, s);
    c && (e.flags |= 32);
};

const cl = (t, n, e, s) => {
    const r = Do(n);
    r && El(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    hl(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[Oe] : null;
    const f = u ? null : r ? n : yl(n, !1);
    const a = u || f?.node;
    const h = fl(t, n, s);
    const d = h?.node ?? null;
    const p = Bo(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = yl(n, !1);
        const c = fl(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        hn(t, e, n => {
            if (Uo(n)) {
                fn(t, ho(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Do(c)) {
                                e = c.node;
                                const t = bl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && yl(l, !0);
                                if (h) {
                                    const t = o(h, bl(c));
                                    s = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = gl(c);
                                a = i(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (kl(e)) {
                                    const t = ne(e);
                                    if (t) {
                                        const n = gl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                fn(t, ho(n.node, a, c));
            }
        });
    } else {
        a && !l && hn(t, e, n => {
            fn(t, ho(n.node, a, d));
        });
    }
    al(n, e, s);
    l && (e.flags |= 32);
};

const fl = (t, n, e) => {
    let s = null;
    e == null ? zo(n) && (s = Zo(n, !0, !1)) : s = zo(e) ? Zo(e, !0, !0) : e;
    s && Uo(s) && tl(t, s);
    return s;
};

const al = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const hl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && ml(t, n, s, !1);
};

const dl = (t, n) => {
    let e = n;
    for (;e && zo(e); ) {
        e = e.lastChild;
    }
    e && Uo(e) && (e.flags & 8) === 0 && tl(t, e);
};

const pl = (t, n, e, s) => {
    Wo(e) ? ul(t, n, e, s) : cl(t, n, e, s);
};

const $l = (t, n) => {
    for (;t && !Do(t); ) {
        if (t.flags & 2048) {
            return t.props?.[Oe];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const yl = (t, n) => {
    for (;t && !Do(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const ml = (t, n, e, s) => {
    Uo(e) && tl(t, e);
    if (s) {
        const s = Ho(n, _s, null) !== null;
        if (s) {
            return;
        }
        Wo(e) ? fn(t, co(e.node)) : hn(t, e, n => {
            fn(t, co(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const wl = (t, n, e, s = !0) => {
    const o = $l(n, !0);
    if (o && s) {
        if (Wo(n)) {
            fn(t, fo(n.node));
        } else {
            const e = yl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? fn(t, fo(o)) : hn(t, n, n => {
                fn(t, co(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const bl = t => {
    const n = xh(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = Ol(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Cl(t);
            switch (n) {
              case rs:
                return 512;

              case is:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const vl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const _l = (t, n, e) => {
    tl(t, n);
    n.text = e;
    fn(t, ao(n.node, e));
};

const gl = t => {
    if (Uo(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && Do(t) && function e(t) {
        const n = t.getAttribute(Th);
        if (n === null) {
            return !1;
        }
        const e = Nl(t);
        return Jl(e) && e.localName === "template" && e.getAttribute(Ph) === n && Ml(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = El(t));
    return n;
};

const El = n => {
    const e = xh(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && kl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = Nl(e);
            const o = jl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Yo(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === Ie && o.charCodeAt(1) === Ie) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = Ll(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = Jl(t);
                            return !n || n && mn(t);
                        };
                        let p = null;
                        Fl(e, ($, y, m, w, b) => {
                            if (Ul($())) {
                                for (;d(o); ) {
                                    o = Ml(o);
                                    if (!o) {
                                        throw Re(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Ul($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = jo(o);
                                    Yo(n);
                                    u(n);
                                    o = Ml(o);
                                    for (;Jl(o) && mn(o); ) {
                                        o = Ml(o);
                                        if (!o && t > 0) {
                                            throw Re(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                Jo(n, Ue, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                Jo(n, Ce, y());
                            } else if ($() === 61) {
                                h || (h = te(s));
                                const t = y();
                                h.Mn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                Jo(n, cs, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Ie;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                Jo(n, fs, y());
                            } else if ($() === 94) {
                                Jo(n, as, y());
                            } else if ($() === 96) {
                                h || (h = te(s));
                                $n(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = te(s));
                                n.slotParent = nl(h.rootVNode, y());
                            } else if ($() === 93) {
                                Jo(n, ze, y());
                            } else if ($() === 123) {
                                m();
                                u(Fo());
                                Bl.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Ie) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const r = w(o + 1) === Ie;
                                let i;
                                if (r) {
                                    m();
                                    i = decodeURI(t(y()));
                                    m();
                                } else {
                                    i = t(y());
                                }
                                Jo(n, s, i);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = Bl.pop();
                                l = Bl.pop();
                                c = Bl.pop();
                                i = Bl.pop();
                                n = Bl.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                Jo(n, Le, e);
                            } else {
                                for (;Jl(o) && mn(o); ) {
                                    o = Ml(o);
                                }
                                const t = o && Tl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;zl($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Rr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = te(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return Ll(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Sl = null;

const kl = t => {
    Sl || (Sl = t.hasAttribute);
    return Sl.call(t, Ze);
};

let Rl = null;

const Pl = (t, n) => {
    Rl || (Rl = t.getAttribute);
    return Rl.call(t, n);
};

const Tl = Co("nodeType");

const ql = t => {
    const n = Tl(t);
    return n === 3 || n === 1;
};

let Al = null;

const Ml = t => {
    Al || (Al = No(t, "nextSibling"));
    Il || (Il = No(t, "firstChild"));
    for (;t; ) {
        t = Al.call(t);
        if (t !== null) {
            const n = Tl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Ge)) {
                    return pn(t, Qe, Al, Il);
                }
                if (t.nodeValue?.startsWith(Ye)) {
                    return pn(t, [ Qe, Ke ], Al, Il);
                }
                if (n?.startsWith(Ze)) {
                    for (;t && (t = Al.call(t)) && (Tl(t) !== 8 || !t.nodeValue?.startsWith(ts)); ) {}
                }
            }
        }
    }
    return t;
};

function pn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = xl(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const xl = Co("parentNode");

let Il = null;

const Nl = t => {
    Il || (Il = No(t, "firstChild"));
    t = t && Il.call(t);
    if (t && Tl(t) === 8) {
        Al || (Al = No(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Ge)) {
            return pn(t, Qe, Al, Il);
        }
    }
    for (;t && !ql(t); ) {
        t = Ml(t);
    }
    return t;
};

const Cl = Co("namespaceURI");

const Ol = Co("nodeName");

const jl = Co("ownerDocument");

const Ll = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;Jl(i) && mn(i); ) {
            i = Ml(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = Tl(i);
        let e = null;
        if (n === 3) {
            e = Lo(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = jo(i);
            Yo(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = Ml(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Fl(e, (e, s) => {
            if (e() === 61) {
                n || (n = te(t.node));
                const e = s();
                n.Mn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = te(t.node));
                $n(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function $n(t, n, e) {
    if (t[mr]) {
        const s = t[mr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, mr, {
            get() {
                const s = e._(n);
                t[mr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, mr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Fl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const Xl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Go(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(vs) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Dl = (t, n) => {
    let e = Wl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Wl(e);
    }
    return !1;
};

const Wl = t => t.parent || t.slotParent;

const Vl = t => {
    if (t === null || zo(t)) {
        return null;
    }
    return t.node;
};

function yn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Do(e)) {
                        const t = ee(e.node);
                        if (!t) {
                            return null;
                        }
                        return ne(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Uo(i)) {
            c.push(Sn(vl(i)));
        } else if (zo(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Xl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== qe && e !== "__scopedStyleIdPrefix__") {
                        const t = Ho(i, e, null);
                        s.push(" " + e + "=" + Sn(t));
                    }
                }
            }
            const l = (o ? "[34m" : "") + (Ae[Ho(i, qe, null) || "V"] || Ae.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = gl(i);
            u && c.push("  " + yn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Do(i)) {
            const s = bl(i);
            const l = [];
            on(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Xl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Ho(i, n, null);
                l.push(" " + n + "=" + Sn(e));
            }
            const f = Vl(i);
            if (f) {
                const t = jl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Sn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Sn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Vo(i) || e) {
                const e = gl(i);
                e && c.push("  " + yn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Ul = t => 48 <= t && t <= 57;

const zl = t => 97 <= t && t <= 122;

function mn(t) {
    return !t.hasAttribute(vs) || t.nodeName === "STYLE" && (t.hasAttribute(Ue) || t.hasAttribute(De));
}

const Bl = [];

const Hl = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Re(26, [ n ]);
};

const Jl = t => t && typeof t == "object" && Tl(t) === 1;

const Ql = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!zo(t) || Ho(t, Ce, null) === null); ) {
            const e = t.slotParent;
            const s = zo(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function wn(t, n) {
    Xo(n) && Do(n) && El(n);
    const e = n[mr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        bn(t, n);
    }
    e.clear();
}

function bn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Vr) {
            _n(s, n);
        } else if (s instanceof Xr) {
            vn(t, s, n);
        } else if (ii(s)) {
            const t = s[Hr];
            gn(t, n);
        } else if (t.ht.has(s)) {
            const e = t.ht.get(s);
            const o = au(e);
            gn(o, n);
        }
    }
    e.clear();
}

function vn(t, n, e) {
    const s = n.ut;
    s && s.has(e) && s.delete(e);
    if (n instanceof _i && !s?.size) {
        n.m = void 0;
        wn(t, n);
    }
}

function _n(t, n) {
    const e = t.ut;
    e && e.has(n) && e.delete(n);
    const s = t.dt;
    s && s.has(n) && s.delete(n);
    const o = t.$t;
    o && o.has(n) && o.delete(n);
    t.yt();
}

function gn(t, n) {
    const e = t?.ut;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Yl = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = $o();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Kl(6 | i, r, o.m, t, void 0, null);
    s(c);
    const l = o.$;
    const {Ft: u} = o;
    const f = Rs(u, () => Gl(c, l, o.m));
    Ss(f) && (o.Ft = f);
};

const Gl = (t, n, e) => {
    const s = t.xn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = Rs(((t, n) => {
        const e = t.In;
        if (e) {
            return e;
        }
        const s = t.Pn;
        if (!s) {
            return;
        }
        t.Pn = null;
        try {
            const e = s();
            if (Ss(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.In === s && (t.In = void 0);
                });
                t.In = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = ce(n.Ot, e, "qTask");
        s.$ = n;
        const i = t.wt.getFn(s, () => wn(n, t));
        const c = Fr(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.Pn = () => {
                            t.Pn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Ss(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return ks(() => i(u), l, s => {
            if (Ss(s)) {
                return s.then(() => {
                    t.xn === r && (t.xn = null);
                    return Gl(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Ss(i)) {
        r = i.finally(() => {
            t.xn === r && (t.xn = null);
        });
        t.xn = r;
        return r;
    }
    return i;
};

class Kl extends wr {
    h;
    Jt;
    ct;
    wt;
    Ct;
    Pn;
    In;
    xn=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Jt = n;
        this.ct = e;
        this.wt = s;
        this.Ct = o;
        this.Pn = r;
    }
}

const Zl = t => t instanceof Kl;

function En(t, n) {
    const e = te(n);
    typeof this === "string" && Tf(qf(e, this));
    const s = Pf[0];
    s.h |= 4;
    cn(e, s.ct, 1);
}

const tu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const nu = t => t instanceof Xr;

const eu = (t, n) => {
    t.add(n);
};

const su = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const ru = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Zl(e) ? o = e.wt : e instanceof Dr ? o = e.nn : s === ":" && (o = n.getHostProp(e, Ce));
        o && n.serializationCtx.Mt.add(o);
    }
};

const iu = (t, n) => {
    if (t && (!n || t === n || Ih(t))) {
        return t;
    }
    return n;
};

const ou = (t, n, e) => {
    const s = de;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Zl(o)) {
                o.h |= 4;
                cn(t, o.ct, 1);
            } else if (o instanceof Xr) {
                o.invalidate();
            } else if (r === ":") {
                cn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ft(o, n);
                    cn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof gi) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Ar];
                            if (!o) {
                                o = new Map;
                                s[Ar] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Ar);
                        if (!n) {
                            n = new Map;
                            t.setProp(Ar, n);
                        }
                        n.set(r, c);
                    }
                    cn(t, o, 8);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const lu = t => ge(t) && typeof t[Xc] === "function";

const uu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const cu = [];

function Sn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Zl(t)) {
            return `Task(${Sn(t.wt)})`;
        }
        if (Te(t)) {
            return `Qrl(${t.bt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (cu.includes(t)) {
                return "*";
            }
            cu.length;
            try {
                cu.push(t);
                if (Array.isArray(t)) {
                    return Xo(t) ? "(" + (Ho(t, qe, null) || "vnode") + ")" : t.map(Sn);
                }
                if (nu(t)) {
                    return t instanceof _i ? "WrappedSignal" : t instanceof Dr ? "ComputedSignal" : "Signal";
                }
                if (yu(t)) {
                    return "Store";
                }
                if (Ri(t)) {
                    return fu(t);
                }
                if (Xo(t)) {
                    return "(" + (Ho(t, qe, null) || "vnode") + ")";
                }
            } finally {
                cu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const fu = t => {
    if (Ri(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Jf];
            if (n) {
                const [t] = n;
                return "Component(" + t.bt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Sn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += fu(e);
                    }
                } else {
                    n += fu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const au = t => t[jr];

const hu = t => t?.[Or] || null;

const du = (t, n) => {
    const e = au(t);
    e && e.force(n);
};

const pu = (t, n) => {
    const e = au(t);
    if (e) {
        return (e.ut?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const $u = t => hu(t) || t;

const yu = t => Or in t;

function kn(t, n, e) {
    return new Proxy(n, new wu(e, t || null));
}

const mu = (t, n, e) => {
    if (_e(t) && e) {
        let s = e.ht.get(t);
        if (!s) {
            s = kn(e, t, n);
            e.ht.set(t, s);
        }
        return s;
    }
    return t;
};

class wu {
    h;
    $;
    ut=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = hu(this);
        ou(this.$, this, Tn(n, t, this.ut));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Or) {
                return t;
            }
            if (n === jr) {
                return this;
            }
            return t[n];
        }
        const e = of();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Lt;
            o && Rn(t, Array.isArray(t) ? Lr : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && ge(s) && !Object.isFrozen(s) && !yu(s) && !Object.isFrozen(t)) {
            return mu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? $u(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Pn(n, s, t, this);
        } else {
            Pn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || ou(this.$, this, Tn(t, n, this.ut));
        return !0;
    }
    has(t, n) {
        if (n === Or) {
            return !0;
        }
        if (typeof n === "string") {
            const e = of();
            if (e) {
                const s = e.Lt;
                s && Rn(t, Array.isArray(t) ? Lr : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = of();
        const e = n?.Lt;
        e && Rn(t, Lr, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Rn(t, n, e, s, o) {
    const r = e.ut ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = he;
    const l = __EXPERIMENTAL__.suspense && e instanceof wu && c;
    eu(i, s);
    su(s, t);
    if (c) {
        const i = iu(o, e.$);
        l && i?.tn?.(t, s, n, r);
        ru(s, i);
    }
}

function Pn(t, n, e, s) {
    e[t] = n;
    const o = Tn(e, t, s.ut);
    o && ou(s.$, s, o);
}

function Tn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Lr);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const bu = Symbol();

const vu = [ void 0, null, !0, !1, "", Yr, Gr, Nr, Lr, Qr, Hi, Ui, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const _u = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const gu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch" ];

function qn(t, n, e) {
    let s = n.bt;
    let o = n.vt;
    const r = Us();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Te(t) && t.bt == Pe)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t._t(null, 0, e) + "";
    } else {
        o || (o = t.gt(n.it));
        if (!o) {
            throw Re(14, [ n.bt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.Et(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function An(t, n, e, s) {
    return If(t, n, null, null, e, s);
}

function Mn(t, n) {
    const [e, s, o] = t.split("#");
    return An(e, s, o || null, n);
}

class Eu {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Su {
    Cn;
    On=0;
    kt=[];
    jn=0;
    Ln=new Set;
    Fn=new Map;
    Xn;
    Dn=new Map;
    Wn=0;
    It;
    Vn=typeof Temporal !== "undefined";
    constructor(t) {
        this.Cn = t;
        this.It = t.It;
    }
    async serialize() {
        const t = this.Wn;
        this.Wn = 0;
        try {
            await this.outputRoots();
        } finally {
            this.Wn = t;
        }
    }
    async serializePatch(t, n, e) {
        const s = this.Wn;
        this.Wn = t;
        this.It.write(hr);
        this.Cn.Un = 0;
        try {
            this.It.write(t + "");
            this.It.write(pr);
            this.It.write(hr);
            await this.outputSelectedRoots(n);
            this.It.write(dr);
            const s = this.getForwardRefsPayload();
            this.Cn.Un = s?.length ?? 0;
            if (s || e !== void 0) {
                this.It.write(pr);
                s ? this.outputForwardRefsArray(s) : this.It.write("0");
            }
            if (e !== void 0) {
                this.It.write(pr);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.It.write(ar);
                    this.writeRootRefPath(e);
                    this.It.write(ar);
                }
            }
        } finally {
            this.Wn = s;
        }
        this.It.write(dr);
    }
    zn(t) {
        this.It = t;
    }
    outputArray(t, n, e) {
        this.It.write(hr);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.It.write(pr) : s = !0;
            e(t[n], n);
        }
        this.It.write(dr);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : ar + t + ar;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.It.write(n.slice(s, e));
            this.It.write("<\\/");
            s = e + 2;
        }
        this.It.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.It.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.It.writeRootRefPath(t);
    }
    outputStringChunks(t) {
        this.It.write(ar);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.It.write(e) : typeof e === "number" ? this.writeRootRef(e) : this.writeRootRefPath(e.path);
        }
        this.It.write(ar);
    }
    output(t, n, e) {
        if (t === 1) {
            this.It.write(t + pr);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.It.write(ar);
                this.writeRootRefPath(n);
                this.It.write(ar);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.It.write(t + pr);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.It.write(t + pr + n);
        } else if (typeof n === "string") {
            this.It.write(t + pr);
            this.outputString(n);
        } else {
            this.It.write(t + pr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Cn.getSeenRef(t);
        const o = !e && this.Fn.get(t);
        if (s) {
            s.Xn && this.isSeenInStreamedRoot(s) && (s = this.Cn.Bn(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Cn.Hn(t, this.Xn, n);
            }
            s = this.Cn.Et(t, !0);
        }
        if (s.Xn) {
            if (this.Xn) {
                this.Cn.Jn(s, t);
            } else {
                this.Cn.Jn(s, t, n);
                t = this.Cn.Qn[n];
            }
        }
        if (typeof o === "number") {
            this.kt[o] = s.Jt;
            this.Fn.delete(t);
        }
        const r = t instanceof Mu ? t.Yn : s.Jt;
        if (!this.Xn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Xn; ) {
            t = t.Xn;
        }
        return t.Jt < this.Wn;
    }
    writeValue(t, n) {
        if (jc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                t === Nr ? this.output(3, 7) : t === Lr ? this.output(3, 8) : t === Qr ? this.output(3, 9) : t === bu && this.output(3, 0);
                break;

              case "function":
                if (t === Hi) {
                    this.output(3, 10);
                } else if (t === Ui) {
                    this.output(3, 11);
                } else if (Te(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = qn(this.Cn, t, !0);
                        let o;
                        if (n !== "") {
                            o = [ this.Cn.Et(n), "#", this.Cn.Et(e) ];
                            if (s) {
                                const t = s.split(" ");
                                o.push("#");
                                for (let n = 0; n < t.length; n++) {
                                    n > 0 && o.push(" ");
                                    o.push(+t[n]);
                                }
                            }
                            const r = o.join("");
                            const i = this.Dn.get(r);
                            if (i) {
                                const t = this.Cn.Et(i);
                                this.output(1, t);
                                return;
                            }
                            this.Dn.set(r, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Qf(t)) {
                        throw Re(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Jf];
                        this.Cn.Gn.add(n.bt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Yr) {
                    this.output(3, 5);
                } else if (t === Gr) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof Mu) {
                    this.output(1, t.Yn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Xn;
                        this.Xn = e;
                        this.writeObjectValue(t);
                        this.Xn = n;
                    }
                }
                break;

              default:
                throw Re(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (ii(t)) {
            const n = t[Br];
            this.output(38, [ qu(n), n.varProps, n.constProps, t[Hr].ut ]);
        } else if (t instanceof gi) {
            this.output(39, [ t.data.O, t.data.et ]);
        } else if (t instanceof Cr) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Eu) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (yu(t)) {
            const n = au(t);
            const e = hu(t);
            const s = n.h;
            const o = n.ut;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Cn.ht.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (lu(t)) {
            const n = t[Xc](t);
            if (Ss(n)) {
                const t = this.resolvePromise(n, (t, n) => new ku(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Xn.Jt;
                this.Xn = this.Xn.Xn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        jc(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Cn.Kn(t)) {
            t.Zn.vnodeData[0] |= 16;
            this.output(11, t.Zn.id);
        } else if (t instanceof Xr) {
            if (t instanceof li) {
                const n = function e(t, n) {
                    if (n === Nr) {
                        return n;
                    }
                    return Rs(t.nn.resolved || t.nn.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Xc in n && (e = n[Xc](n));
                        e === void 0 && (e = Nr);
                        return e;
                    });
                }(t, t.Kt);
                if (Ss(n)) {
                    const e = this.resolvePromise(n, (n, e) => new ku(34, n, e, t.ut, t.nn));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.nn, t.ut, n ]);
                }
                return;
            }
            if (t instanceof _i) {
                this.output(31, [ ...xn(this.Cn, t), t.h, t.m, ...t.ut || [] ]);
            } else if (t instanceof Dr) {
                let n = t.Kt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = jc(t.Kt);
                const i = t instanceof Vr;
                const c = i && t.Rt !== 0 ? t.Rt : void 0;
                const l = i && t.$n !== 1 ? t.$n : void 0;
                const u = i && t.mn !== 0 ? t.mn : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Nr : e ? n = t.Kt : s && (n = Nr);
                const a = [ t.nn, t.ut ];
                if (i) {
                    a.push(t.dt, t.$t, t.dn);
                    a.push(f || void 0);
                }
                n === Nr && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? bu : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Kt;
                const e = [ n === void 0 ? bu : n ];
                t.ut && e.push(...t.ut);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Vn && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Vn && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Vn && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Vn && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Vn && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Vn && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Vn && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Vn && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Cn.te(t)) {
            const n = this.Cn.Et(t);
            this.Cn.ne(t, ls, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                Ru(e, t => {
                    this.Cn.Et(t);
                });
                e[0] |= 16;
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    const s = n.vnodeData;
                    s && (s[0] |= 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Ri(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Kl) {
            const n = [ t.wt, t.h, t.Jt, t.ct, t.Ct ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Ss(t)) {
            const n = this.resolvePromise(t, (t, n) => new ku(24, t, n));
            this.output(2, n);
        } else if (t instanceof ku) {
            if (t.ee === 34) {
                if (t.wt) {
                    this.output(34, [ t.wt, t.ut, t.se ]);
                } else {
                    if (!t.re) {
                        console.error(t.se);
                        throw Re(33);
                    }
                    {
                        const n = this.Xn.Jt;
                        this.Xn = this.Xn.Xn;
                        this.writeValue(t.se, n);
                    }
                }
            } else {
                this.output(24, [ t.re, t.se ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof Tu) {
            const n = t.ie;
            if (this.getSeenRefOrOutput(n, this.Xn.Jt, !0)) {
                let t = this.Fn.get(n);
                if (t === void 0) {
                    t = this.jn++;
                    this.Fn.set(n, t);
                    this.kt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else {
            if (!Xo(t)) {
                throw Re(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.jn++;
        t.then(s => {
            this.Ln.delete(t);
            this.kt[e] = this.Cn.Et(n(!0, s));
        }).catch(s => {
            this.Ln.delete(t);
            this.kt[e] = this.Cn.Et(n(!1, s));
        });
        this.Ln.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Cn.oe + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {Qn: n} = this.Cn;
        for (;this.On < n.length || this.Ln.size; ) {
            let e = t > 0;
            for (;this.On < n.length; this.On++) {
                e ? this.It.write(pr) : e = !0;
                this.writeValue(n[this.On], this.On);
                t++;
            }
            if (this.Ln.size) {
                try {
                    await Promise.race(this.Ln);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Ln.size; ) {
            if (e < t.length) {
                n ? this.It.write(pr) : n = !0;
                const s = t[e++];
                this.writeValue(this.Cn.Qn[s], s);
                continue;
            }
            try {
                await Promise.race(this.Ln);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.kt.length - 1;
        for (;t >= 0 && this.kt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.kt.length - 1 ? this.kt : this.kt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.It.write(ar);
                this.writeRootRefPath(t);
                this.It.write(ar);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.It.write(hr);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Cn.le = this.Cn.Qn.length;
        this.Cn.ue = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.It.write(pr);
            this.It.write(14 + pr);
            this.outputForwardRefsArray(n);
        }
        this.It.write(dr);
        this.Cn.ce = this.Cn.Qn.length + (this.Cn.ue ? 1 : 0);
        this.Cn.Un = e;
    }
}

class ku {
    ee;
    re;
    se;
    ut;
    wt;
    constructor(t, n, e, s, o) {
        this.ee = t;
        this.re = n;
        this.se = e;
        this.ut = s;
        this.wt = o;
    }
}

const Ru = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (Pu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === ls || t === cs && cr(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const Pu = t => typeof t === "object" && t !== null && !cr(t);

function xn(t, n) {
    n.St && n.St[0] === "{" && (n.St = `(${n.St})`);
    const e = t._t(n.St, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class Tu {
    ie;
    constructor(t) {
        this.ie = t;
    }
}

const qu = t => new Tu(t);

let Au = () => !1;

class Mu {
    Yn;
    constructor(t) {
        this.Yn = t;
    }
}

class xu {
    NodeConstructor;
    DomRefConstructor;
    gt;
    ne;
    ht;
    It;
    fe=new Map;
    ae=new Map;
    he=0;
    de=[];
    Qn=[];
    pe=[];
    $e;
    oe=0;
    ce=0;
    Un=0;
    le=0;
    ue=!1;
    Pt=new Set;
    Mt=new Set;
    At=new Set;
    Gn=new Set;
    ye;
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.gt = e;
        this.ne = s;
        this.ht = o;
        this.It = r;
        this.ye = new Su(this);
    }
    async xt() {
        await this.ye.serialize();
    }
    async me(t, n, e) {
        await this.ye.serializePatch(t, n, e);
    }
    zn(t) {
        this.It = t;
        this.ye.zn(t);
    }
    getSeenRef(t) {
        return this.fe.get(t);
    }
    Hn(t, n, e) {
        const s = {
            Jt: e,
            Xn: n
        };
        this.fe.set(t, s);
        return s;
    }
    we(t) {
        const n = [];
        for (;t.Xn; ) {
            n.unshift(t.Jt);
            t = t.Xn;
        }
        n.unshift(t.Jt);
        return n;
    }
    Jn(t, n, e) {
        const s = this.we(t);
        const o = e === void 0;
        e === void 0 && (e = this.Qn.length);
        this.Qn[e] = new Mu(s);
        o && (this.pe[e] = n);
        t.Xn = null;
        t.Jt = e;
        o && this.$e?.(e, this.Qn[e], n);
    }
    Et(t, n = !1) {
        let e = this.fe.get(t);
        let s;
        if (e) {
            e.Xn && this.Jn(e, t);
            s = e.Jt;
        } else {
            s = this.Qn.length;
            e = {
                Jt: s
            };
            this.fe.set(t, e);
            this.Qn.push(t);
            this.pe.push(t);
            this.$e?.(s, t, t);
        }
        return n ? e : s;
    }
    Bn(t) {
        const n = this.Qn.length;
        const e = {
            Jt: n
        };
        this.fe.set(t, e);
        this.Qn.push(t);
        this.pe.push(t);
        this.$e?.(n, t, t);
        return e;
    }
    be(t, n) {
        const e = this.Qn.length;
        const s = {
            Jt: e
        };
        this.fe.set(n, s);
        this.Qn.push(t);
        this.pe.push(n);
        return e;
    }
    te(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Kn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ve(t) {
        const n = this.fe.get(t);
        return n && (n.Xn ? void 0 : n.Jt);
    }
    _t(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.ae.get(t);
        if (o === void 0) {
            o = this.he + this.de.length;
            this.ae.set(t, o);
            if (s) {
                this.de.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.de.push(e += ")=>" + t);
            }
        }
        return o;
    }
    _e(t, n) {
        this.he = t;
        if (n) {
            this.ae.clear();
            for (let t = 0; t < n.length; t++) {
                this.ae.set(n[t], t);
            }
        }
    }
}

const Iu = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(fr(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    Au = n ? t => t instanceof n : () => !1;
    return new xu(t, n, e, s, o, r);
};

const Nu = (t, n) => t[n];

const Cu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        yu(t) && (t = hu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Cu(ff(Nu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Cu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Zl(t)) {
            return !0;
        }
        if (ii(t)) {
            return !0;
        }
        if (Ss(t)) {
            return !0;
        }
        if (Ri(t)) {
            return !0;
        }
        if (lu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof gi) {
            return !0;
        }
        if (Au?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Te(t) || Qf(t) || t === Hi || t === Ui) {
            return !0;
        }
    } else if (t === Qr || t === Nr || t === Lr) {
        return !0;
    }
    return !1;
};

const Ou = (t, n) => {
    let e = Xo(t) ? yn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (ge(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let ju = !1;

const Lu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (ju = !0);
            const n = `{${ge(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Ou(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Xu(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Lu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Fu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = ju ? "" : `(${JSON.stringify(t).length} chars)`;
        ju = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Fu = t => gu[t] || `Unknown(${t})`;

const Xu = t => _u[t] || `Unknown(${t})`;

function In(t, n, e, s = 0) {
    const o = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const r = t => t === 14;
    const i = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let e = s; e < t.length; e += 2) {
        o(t[e], t[e + 1]) ? i(e) : r(t[e]) && (n.kt = t[e + 1]);
    }
}

const Du = new WeakMap;

const Wu = new Map;

const Vu = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Nt(e);
        return s === -1 || s === void 0 ? Qr : t._(s);

      case 14:
        return e;

      case 3:
        return vu[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = An(i, c, r || null, t);
            } else {
                n = An("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Kl(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Hf(null);

      case 30:
        return new Xr(t, 0);

      case 31:
        return new _i(t, null, null, null);

      case 32:
        return new Dr(t, null);

      case 33:
        return new Vr(t, null, void 0, {});

      case 34:
        return new li(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Vu(t, s, o);
            const i = mu(r, 0, t);
            Tc(s) && Wu.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Si(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Du.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return w(null);

      case 10:
        return Nn(t, e);

      case 11:
        const h = Nn(t, e);
        if (Xo(h)) {
            El(h);
            return Vl(h);
        }
        throw Re(17, [ typeof h ]);

      case 39:
        return new gi({});

      case 40:
        return new Cr(null, null, null, null);

      case 41:
        return new Eu;

      default:
        throw Re(18, [ n ]);
    }
};

function Nn(t, n) {
    return n ? t.rootVNode ? nl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Uu = (t, n, e) => {
    let s = null;
    let o = null;
    if (ke(t)) {
        o = t;
    } else {
        if (!Se(t)) {
            throw Re(7, [ t ]);
        }
        s = t;
    }
    return If(s, n, null, o, e);
};

const zu = (t, n, e) => If(null, n, t, null, e);

const Bu = (t, n) => If(null, t, null, null, n);

const Hu = (t, n, e) => {
    const s = Bu(t, e);
    return s;
};

const Ju = (t, n, e, s) => If(t, e, null, n, s);

const Qu = (t, n, e, s, o) => {
    const r = Ju(t, n, e, o);
    r.ge(s);
    return r;
};

const Yu = (t, n, e, s) => {
    const o = Uu(t, n, s);
    return o;
};

const Gu = (t, n, e, s) => {
    const o = zu(t, n, s);
    return o;
};

const Ku = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Zu = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Cn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const tc = (t, n, e) => new _i(null, t, n, e || null);

class nc {
    Ee;
    ht;
    Se=null;
    Nn=!1;
    Ot;
    _;
    Xt;
    ke=0;
    Re=null;
    Pe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Xt = t;
        this.Ot = n;
        this.Ee = $r;
        this.ht = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return df(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return Iu(t, n, e, this.setHostProp.bind(this), this.ht, s);
    }
    ft() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const ec = Symbol();

const Nh = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[ec] = t;
    return n;
};

class sc {}

function On(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function jn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === sc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Ss(n) && await n;
                    }
                    continue;
                }
                Ln(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Ss(n) && await n;
            }
        }
    })();
}

function Ln(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (nu(e)) {
            (function s(t, n) {
                const e = n instanceof _i ? n.rt() : n;
                if (e instanceof Vr) {
                    const n = e.Rt;
                    if (n && !(e.h & 256)) {
                        t.Et(e);
                        t.Pt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(Gr);
            const o = t.getOrCreateLastNode();
            const r = e instanceof _i ? e.rt() : e;
            n(t.closeFragment);
            n(() => df(r, o, ".", t));
            n(sc);
        } else if (Ss(e)) {
            t.openFragment(Gr);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await jn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = ni(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.Tt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (ke(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && ec in t)(r)) {
                    n(() => (t => t[ec])(r)(t, o, s, n));
                    return;
                }
                if (r === Ui) {
                    const e = o.key != null ? {
                        [us]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === Hi) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = ni(o, ws);
                        c && (i[ws] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = M(l, o, t);
                        i[Le] = f;
                        n(On(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(On(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Gr;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Yi) {
                    t.commentNode(ni(o, "data") || "");
                } else if (r === Ki) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = ke(e) ? e({
                        async write(n) {
                            await jn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    Ss(r) && n(Promise);
                } else if (r === Qi) {
                    t.htmlNode(ni(o, "data"));
                } else if (r === Gi) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (Qf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Jf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Ce, o);
                        s.setProp(cs, r);
                        n.key !== null && s.setProp(us, n.key);
                        return Bi(t, s, s, o, r);
                    })(t, o, r);
                    n(On(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Ss(l)) {
                        n(async () => {
                            const t = await l;
                            const e = qs(i.getProp(Ue));
                            n(t);
                            n(On(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = qs(i.getProp(Ue));
                        n(On(s, t, c));
                    }
                } else {
                    const e = {
                        [us]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Bi(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    Ss(i) && n(Promise);
                }
            }
        }
    }
}

const rc = new Set([ "allowStale", "clientOnly", "concurrency", "container", "eagerCleanup", "expires", "initial", "interval", "poll", "serializationStrategy", "timeout" ]);

const ic = (t, n) => {
    t.resolve();
    return ci(t, n);
};

const oc = async t => {
    const [n, e] = Pf;
    const s = cc(n) ? n : await n.resolve();
    return await s(t.abortSignal, e);
};

const lc = (t, n, e) => {
    if (e !== void 0 || !fc(n)) {
        return ((t, n, e) => {
            const {val: s, set: o, iCtx: r} = $o();
            if (s) {
                return s;
            }
            const i = If(null, "_uas", oc, null, [ t, n ], r.$);
            i.resolve();
            const c = e?.container ? e : {
                ...e,
                container: r.$
            };
            const l = ci(i, c);
            l.__qwik_async_resource__ = {
                input: n,
                qrlHash: t.getHash()
            };
            return o(l);
        })(t, n, e);
    }
    return wo(ic, t, n);
};

const uc = oi(lc);

const cc = t => !!t && typeof t === "function" && t.__qwik_server_function__ === !0;

const fc = t => {
    if (t == null) {
        return !0;
    }
    if (typeof t !== "object") {
        return !1;
    }
    for (const n of Object.keys(t)) {
        if (rc.has(n)) {
            return !0;
        }
    }
    return !1;
};

const ac = () => Pf;

const hc = async t => {
    const [n, e] = Pf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = kn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const dc = (t, n) => {
    const {val: e, set: s, iCtx: o} = $o();
    if (e) {
        return e;
    }
    const r = If(null, "_rsc", hc, null, [ t, {} ], o.$);
    const i = ci(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const pc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Ss(t)) {
        return t.then(n, s);
    }
    const o = $c(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return Ss(i) ? i.then(n, s) : n(i);
};

const $c = t => t && t.__brand === "resource";

function Fn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n.bt.startsWith("_") || !n.qt?.length && !s || (n = If(null, "_run", F, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = qn(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            const c = o.split(" ");
            for (let t = 0; t < c.length; t++) {
                t > 0 && i.push(" ");
                i.push(+c[t]);
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Te(o)) {
                i(c(o));
                Xn(t, n, o);
            } else if (o != null) {
                const e = Fn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Te(r)) {
        o = c(r);
        Xn(t, n, r);
    }
    return o;
}

function Xn(t, n, e) {
    const s = Is(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.At.add(r);
        t.Mt.add(e);
    }
}

const yc = (t, n, e) => {
    bc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const mc = (t, n, e) => {
    bc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const wc = (t, n, e) => {
    bc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const bc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = vc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + xs(i), e, s);
            }
        } else {
            r(t + xs(n), e, s);
        }
    }
};

const vc = () => {
    const t = uf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, $s);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, $s, s);
    }
    let o = t.$.getHostProp(e, ys);
    o === null && (o = 0);
    t.$.setHostProp(e, ys, o + 1);
    let r = t.$.getHostProp(e, ms);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, ms, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const _c = function(t, n) {
    if (!t.detail.files.some(t => n.getAttribute("data-qwik-inspector")?.startsWith(t))) {
        return;
    }
    if (typeof this === "string") {
        const t = te(n);
        Tf(qf(t, this));
    }
    const e = Pf[0];
    const s = te(n);
    cn(s, e, 4);
    const o = n.ownerDocument;
    o.__hmrDone = o.__hmrT;
};

let gc;

function Dn() {
    const t = of();
    if (!t) {
        return;
    }
    gc ||= zu(_c, "_hmr");
    const n = t.m;
    const e = gc.w([ n ]);
    mc("qHmr", e);
}

function Wn(t, n, e, s, o) {
    const r = Fo();
    Jo(r, Le, o);
    r.parent = n;
    Jo(n, o, r);
    Jo(r, Ce, e);
    Jo(r, cs, s);
    r.dirty = 4;
    rn(t, r, 1);
    return r;
}

function Vn(t, n) {
    Jo(t, Oe, n);
    t.flags |= 2048;
}

function Un(t, n, e) {
    Jo(n, cs, e);
    cn(t, n, 4);
}

function zn(t, n, e, s) {
    Jo(n, s, null);
    const o = [];
    qt(t, o, e);
    ll(o);
    if (e.flags & 2048) {
        const t = Ho(e, Oe, null);
        t && t.replaceChildren();
        Jo(e, Oe, null);
        e.flags &= -2049;
    }
}

let Ec = Promise.resolve();

const Sc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const kc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Sc.has(t));
};

const Rc = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = Pc(t, s));
    switch (e) {
      case 4:
        Pc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!kc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.wt = r[0];
        o.h = r[1];
        o.Jt = r[2];
        o.ct = r[3];
        o.Ct = r[4];
        break;

      case 29:
        n[Jf][0] = s[0];
        break;

      case 35:
        {
            const e = $u(n);
            const o = Wu.get(e);
            if (o) {
                Wu.delete(e);
                Rc(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = au(n);
            c.h = r;
            c.ut = i;
            Jn(c.ut, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Kt = e[0];
            t.ut = new Set(e.slice(1));
            Hn(t.ut, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Kt = Nr;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ut = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && Xo(t.m)) {
                    const n = t.m;
                    const e = t.ut;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Se(e)) {
                                const o = Ho(n, e, null);
                                if (o !== null) {
                                    t.Kt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = gl(n);
                        e && n.firstChild === n.lastChild && Uo(e) && (t.Kt = vl(e));
                    }
                }
            })(e);
            Hn(e.ut, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.nn = e[0];
            e[1] && (t.ut = new Set(e[1]));
            e[2] && (t.dt = new Set(e[2]));
            e[3] && (t.$t = new Set(e[3]));
            e[4] && (t.dn = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.hn = !0);
            const o = e.length > 6;
            o && (t.Kt = e[6]);
            t.Kt === Nr && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.$n = e[8] ?? 1;
                t.yn = [];
            }
            t.mn = e[9] ?? 0;
            Hn(t.ut, t);
            Hn(t.dt, t);
            Hn(t.$t, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.nn = r[0];
            const i = o.nn.resolve(t).catch(() => {});
            Ec = Ec.finally(() => i);
            r[1] && (o.ut = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Kt = r[2]);
            e !== 34 && o.Kt !== Nr && (o.h &= -2);
            Hn(o.ut, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Du.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === Qr) {
            a = new Si(Ui, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[Br] = a;
        const h = u[Hr];
        h.ut = f[3];
        Jn(h.ut, u);
        break;

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = he;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[mr] ||= new Map;
                e[mr].set(t.property, t);
            })(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      default:
        throw Re(16, [ e ]);
    }
};

const Pc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Bn(t, n[s], n[s + 1]);
    }
    return e;
};

function Bn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Vu(t, n, e);
    Tc(n) && Rc(t, s, n, e);
    return s;
}

function Hn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Jn(t, n) {
    if (t) {
        for (const [, e] of t) {
            Hn(e, n);
        }
    }
}

const Tc = t => t >= 23 || t === 4 || t === 5;

const qc = new WeakMap;

const Ac = Symbol();

const Mc = (t, n) => {
    if (!Array.isArray(n) || Xo(n) || (t => ge(t) && Ac in t)(n)) {
        return n;
    }
    let e = qc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new xc(t, n));
        qc.set(n, e);
    }
    return e;
};

class xc {
    $;
    Te;
    constructor(t, n) {
        this.$ = t;
        this.Te = n;
    }
    get(t, n, e) {
        if (n === Ac) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Te.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Te[o];
        const i = this.Te[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Vu(c, r, i);
        Reflect.set(t, n, l);
        this.Te[o] = 0;
        this.Te[o + 1] = l;
        Tc(r) && Rc(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === Ac) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Ac) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Te.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Te[i] = 0;
        this.Te[i + 1] = e;
        return !0;
    }
}

async function Qn(t) {
    const n = Iu(null, null, () => "", () => {}, new WeakMap);
    n.Et(t);
    await n.xt();
    return n.It.toString();
}

function Yn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Kn(n);
    return Bn(e, n[0], n[1]);
}

function Gn(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function Kn(t) {
    let n;
    const e = {
        _: t => Gn(t, n),
        Nt: t => e.kt?.[+t],
        getSyncFn: () => () => {},
        ht: new WeakMap,
        element: null,
        kt: null
    };
    In(t, e);
    n = Mc(e, t);
    e.Ct = n;
    return e;
}

const Ic = (t, n) => {
    const e = new WeakSet;
    return ff(Nc, t, e, "_", n);
};

const Nc = (t, n, e, s) => {
    const o = $u(t);
    if (o == null) {
        return t;
    }
    if (Oc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (nu(o)) {
            return t;
        }
        if (Cu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (Ss(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Ee(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Re(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Re(3, [ o ]);
                    }
                    Nc(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Er) {
                return t;
            }
            if (_e(o)) {
                for (const [t, s] of Object.entries(o)) {
                    Nc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Re(3, [ i ]);
    }
    return t;
};

const Cc = /*#__PURE__*/ new WeakSet;

const Oc = t => {
    if (ge(t) || ke(t)) {
        return !Cc.has(t) && !(Fc in t);
    }
    return !0;
};

const jc = t => !!t && (ge(t) || typeof t === "function") && (Cc.has(t) || Fc in t);

const Lc = t => {
    (ge(t) && t !== null || typeof t === "function") && Cc.add(t);
    return t;
};

const Fc = Symbol();

const Xc = Symbol();

const Dc = t => /*#__PURE__*/ Object.freeze({
    id: xs(t)
});

const Wc = (t, n) => {
    const {val: e, set: s, iCtx: o} = $o();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const Vc = (t, n) => {
    const {val: e, set: s, iCtx: o} = $o();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(oe(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Re(8, [ t.id ]);
};

const Uc = t => {
    const n = lf();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const zc = /*#__PURE__*/ Dc("qk-error");

const Ch = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Oh = new WeakMap;

class jh {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Lh(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Ch(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Lh = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Fh = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = of()?.$;
    return t?.outOfOrderStreaming === !0 && !Ih(t);
};

const Bc = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && ou(t, n, r);
};

const Hc = new WeakMap;

const Jc = (t, n) => {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`${Yc(e.Re)}${Xe}`);
    const o = Qc(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(Ph) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        Gc(t, e, i.textContent);
    }
};

const Qc = t => {
    let n = Hc.get(t);
    if (!n) {
        n = new WeakSet;
        Hc.set(t, n);
    }
    return n;
};

const Yc = t => `script[type="qwik/state"][q\\:instance="${t}"]`;

const Gc = (t, n, e) => {
    if (e) {
        const [s, o, r, i] = JSON.parse(e);
        Kc(t, n, s, o);
        Zc(n, r || void 0);
        ((t, n) => {
            if (!__EXPERIMENTAL__.suspense || !n) {
                return;
            }
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                const o = t._(s.rootId);
                const r = s.subscriptions;
                if (o instanceof Xr) {
                    r instanceof Set && Bc(t, o, o, o.ut ||= new Set, r);
                } else {
                    if (!(r instanceof Map)) {
                        continue;
                    }
                    const n = au(o);
                    const e = hu(o);
                    if (!n || !e) {
                        continue;
                    }
                    const s = n.ut ||= new Map;
                    for (const [o, i] of r) {
                        let r = s.get(o);
                        if (!r) {
                            r = new Set;
                            s.set(o, r);
                        }
                        Bc(t, n, e, r, i);
                    }
                }
            }
        })(t, i === void 0 ? void 0 : n._(i));
    }
};

const Kc = (t, n, e, s) => {
    const o = n.qe.length / 2;
    if (e !== o) {
        return;
    }
    for (let t = 0; t < s.length; t++) {
        n.qe[e * 2 + t] = s[t];
    }
    In(n.qe, t, 0, e * 2);
    n.Ae = Mc(t, n.qe);
    n.Ae.length = n.qe.length / 2;
    n.Me = n.kt;
};

const Zc = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Me ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.kt = e;
};

function Zn(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const m = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const w = t => {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && w(s);
        }
    };
    const b = t => {
        const n = m.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = (n, e, s, o, r, i, c, l) => {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let m = 0;
        let w = 0;
        let E = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;tf(w = r.charCodeAt(y)); ) {
                t += 1 << w - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && v(t.createTreeWalker(e, 129), null, e, null, "", null, null);
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = m;
                    if (y < f) {
                        p += k();
                        if (w === 126) {
                            E = p;
                            y++;
                            w = y < f ? r.charCodeAt(m) : 33;
                        }
                        m = nf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    E !== h || u && s === e || i.set(u ? Ne(l, h) : h, s);
                    const t = r.substring(y, m);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== Ie || n.charCodeAt(1) !== Ie || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    g(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
        } while (s = S || n.nextNode());
    };
    const g = __EXPERIMENTAL__.suspense ? (n, e, s, o) => {
        const r = n?.qVNodeRefs;
        o ||= n?.qSegmentVnodeData?.get(s);
        if (!o || !r) {
            return;
        }
        const i = t.createTreeWalker(t, 129);
        i.currentNode = e;
        v(i, e, e, _(e), o, r, n, s);
    } : null;
    if (__EXPERIMENTAL__.suspense && n !== void 0) {
        e.qVNodeRefs ||= new Map;
        g(e, s, n, o);
        return;
    }
    w(t);
    const E = t.createTreeWalker(t, 129);
    v(E, null, E.firstChild(), null, "", null, null);
}

const tf = t => 33 <= t && t <= 46;

const nf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && tf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function te(t) {
    const n = ee(t);
    if (!n) {
        throw Re(24);
    }
    return ne(n);
}

function ne(t) {
    const n = t;
    return n.qContainer ||= new ef(n);
}

function ee(t) {
    return t.closest(es);
}

function se(t, n) {
    const e = n + "";
    const s = t.currentScript?.closest(es);
    (function o(t, n, e) {
        if (!__EXPERIMENTAL__.suspense) {
            return;
        }
        const s = e.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]`);
        const o = s?.closest("[q\\:container]");
        const r = o?.querySelector(`[q\\:rp="${n}"]`);
        s && o && r && Zn(t, n, o, r, s.textContent);
    })(t, e, s || t);
    const r = s?.qContainer;
    if (r) {
        Jc(r, e);
    } else {
        const n = t.querySelectorAll(es);
        for (let t = 0; t < n.length; t++) {
            const s = n[t].qContainer;
            s && Jc(s, e);
        }
    }
}

class ef extends nc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    ht=new WeakMap;
    xe;
    Re;
    kt=null;
    vNodeLocate=t => nl(this.rootVNode, t);
    qe;
    Ae;
    Me=null;
    Ie=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Ze);
        if (!this.qContainer) {
            throw Re(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.Pe = t.getAttribute(Je);
        this.Re = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = jo(this.element);
        this.qe = [];
        this.Ae = [];
        const n = this.element.ownerDocument;
        n.qVNodeData || function e(t) {
            Zn(t);
        }(n);
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= se);
        this.xe = He(n, this.Re) || Yr;
        this.Ne();
        t.setAttribute(Ze, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.Pn();
        this.Ce();
        __EXPERIMENTAL__.suspense && Jc(this);
        this.Oe();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    Pn() {
        this.vNodeLocate = () => null;
        this.qe.length = 0;
        this.Ae.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Ze);
        const n = t.ownerDocument;
        const e = n.querySelector(es) !== null;
        e || (n.qVNodeData = void 0);
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    Ce() {
        const t = this.element.querySelector(`${this.je()}:not(${Xe})`);
        if (t) {
            this.qe = JSON.parse(t.textContent);
            In(this.qe, this);
            this.Me = this.kt;
            this.Ae = Mc(this, this.qe);
        }
    }
    je() {
        return `script[type="qwik/state"][q\\:instance="${this.Re}"]`;
    }
    Oe() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Ve);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Mn(t, n) {
        this.Ae[t] = n;
    }
    parseQRL(t) {
        const n = Mn(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, zc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, ze);
        s == null && this.setHostProp(t, ze, s = []);
        we(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, ze);
            if (e != null && ve(e, n.id, 0)) {
                return be(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (zo(n)) {
                if (Ho(n, Ce, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        Jo(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case fs:
          case cs:
          case Ce:
          case ze:
          case Be:
          case ws:
            s = this._;
            break;

          case as:
          case ys:
            s = parseInt;
            break;
        }
        return Ho(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (A(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => Gn(t, this.Ae);
    Nt(t) {
        return this.Me?.[t];
    }
    getSyncFn(t) {
        const n = this.xe[t];
        return n;
    }
    Le(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Ue);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Ue, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ie == null) {
            this.Ie = new Set;
            const t = this.document.querySelectorAll(We);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ie.add(e.getAttribute(De));
            }
        }
        if (!this.Ie.has(n)) {
            this.Ie.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(De, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ne() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === vs) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Xt = {
            containerAttributes: t
        };
    }
}

let sf;

let Xh;

if (he) {
    const t = Zu();
    t && (Xh = new t);
}

function re(t) {
    if (Xh) {
        const t = Xh.getStore();
        if (t) {
            return t;
        }
    }
    if (sf === void 0) {
        const n = of();
        if (n && n.Ot) {
            return n.Ot;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return sf;
}

function ie(t, n) {
    if (Xh) {
        return Xh.run(t, n);
    }
    const e = sf;
    try {
        sf = t;
        return n();
    } finally {
        sf = e;
    }
}

let rf;

const of = () => rf;

const lf = () => {
    const t = of();
    if (!t) {
        throw Re(9);
    }
    return t;
};

const uf = () => {
    const t = of();
    if (!t || t.jt !== os) {
        throw Re(10);
    }
    return t;
};

function oe(t, n, ...e) {
    return le.call(this, t, n, e);
}

function le(t, n, e) {
    const s = rf;
    try {
        rf = t;
        return n.apply(this, e);
    } finally {
        rf = s;
    }
}

const cf = (t, n) => {
    const e = te(n);
    const s = nl(e.rootVNode, n);
    const o = e.Ot;
    o && function r(t) {
        if (Xh) {
            Xh.enterWith(t);
            return;
        }
        sf = t;
    }(o);
    const i = ce(o, s, t);
    i.$ = e;
    return i;
};

function ue(t, n, e) {
    const s = {
        m: n,
        jt: os,
        Lt: void 0,
        Ot: t,
        $: e,
        Ft: void 0
    };
    return s;
}

function ce(t, n, e) {
    const s = t || (e && ge(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        jt: e,
        Lt: void 0,
        Ot: s,
        $: void 0
    };
    return o;
}

const ff = (t, ...n) => {
    if (typeof t === "function") {
        if (!rf) {
            return t(...n);
        }
        {
            const e = rf.Lt;
            try {
                rf.Lt = void 0;
                return t(...n);
            } finally {
                rf.Lt = e;
            }
        }
    }
    if (nu(t)) {
        return t.untrackedValue;
    }
    return $u(t);
};

const af = /*#__PURE__*/ ue(void 0, void 0, void 0);

const hf = (t, n, e, s, o) => {
    const r = af.Lt;
    const i = af.$;
    try {
        af.Lt = m(n, e, o);
        af.$ = s;
        return le(af, t);
    } finally {
        af.Lt = r;
        af.$ = i;
    }
};

const df = (t, n, e, s, o) => {
    t instanceof _i && t.m !== n && n && (t.m = n);
    return hf(() => t.value, n, e, s, o);
};

const pf = () => of()?.m;

const $f = () => {
    const t = of();
    if (t) {
        return t.jt;
    }
};

const yf = () => {
    const t = of();
    if (t) {
        return t.$;
    }
};

const mf = t => t;

const wf = t => t.l || Promise.resolve();

let bf = (t, n, e, s, o) => new vf(t, n, e, s, o);

class vf {
    vt;
    bt;
    Fe;
    Xe;
    $;
    constructor(t, n, e, s, o) {
        this.vt = t;
        this.bt = n;
        this.Fe = e;
        this.Xe = s;
        s && this.De(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        de && t && ae(t, .8);
    }
    get it() {
        return Rh(this.bt);
    }
    De(t) {
        this.Xe = t;
        Ss(t) && t.then(t => this.Xe = t, t => {
            console.error(`qrl ${this.bt} failed to load`, t);
            this.Xe = null;
        });
    }
    We() {
        if (this.Xe != null) {
            return this.Xe;
        }
        if (this.vt === "") {
            const t = this.$.Re;
            const n = this.$.element?.ownerDocument || document;
            const e = He(n, t);
            return this.Xe = e[+this.bt];
        }
        de && this.vt && ae(this.vt, 1);
        const t = this.bt;
        const n = this.Fe ? this.Fe().then(n => n[t]) : Us().importSymbol(this.$?.element, this.vt, t);
        this.De(n);
        return this.Xe;
    }
}

de && import.meta.hot && (t => {
    if (!de || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        bf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.vt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.vt;
            if (i) {
                t.vt = e(i, o);
                r = !0;
            }
            const c = t.Fe?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.Fe = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.bt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.bt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.Xe = void 0;
                document.__hmrDone = document.__hmrT;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    });
})(vf);

const _f = Symbol();

const gf = t => t?.[_f] ?? t;

class Ef {
    Ve;
    resolved=void 0;
    qt;
    $;
    constructor(t, n, e) {
        this.Ve = t;
        if (n) {
            this.qt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.Xe == null || typeof this.qt === "string" || Ss(t.Xe) || (this.resolved = Mf(this, t.Xe));
    }
}

const Sf = function(t, ...n) {
    const e = gf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = of();
    return kf.call(e, s?.$).then(() => le.call(t, s, e.resolved, n));
};

const kf = async function(t) {
    const n = gf(this);
    return Rs(xf(n, t), () => n.resolved);
};

const Rf = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[_f].resolved;
        },
        set(t) {
            this[_f].resolved = t;
        }
    },
    qt: {
        get() {
            return this[_f].qt;
        },
        set(t) {
            this[_f].qt = t;
        }
    },
    $: {
        get() {
            return this[_f].$;
        },
        set(t) {
            this[_f].$ = t;
        }
    },
    Ve: {
        get() {
            return this[_f].Ve;
        }
    },
    vt: {
        get() {
            return this[_f].Ve.vt;
        }
    },
    bt: {
        get() {
            return this[_f].Ve.bt;
        }
    },
    it: {
        get() {
            return this[_f].Ve.it;
        }
    },
    dev: {
        get() {
            return this[_f].Ve.dev;
        }
    },
    Ue: {
        value: Sf
    },
    w: {
        value: function(t) {
            const n = gf(this);
            const e = new Ef(n.Ve, t, n.qt ? n.$ : void 0);
            return Nf(e);
        }
    },
    s: {
        value: function(t) {
            const n = gf(this);
            n.Ve.De(t);
            n.resolved = Mf(n, t);
        }
    },
    resolve: {
        value: kf
    },
    getSymbol: {
        value: function() {
            return gf(this).Ve.bt;
        }
    },
    getHash: {
        value: function() {
            return gf(this).Ve.it;
        }
    },
    getCaptured: {
        value: function() {
            const t = gf(this);
            Af(t);
            return t.qt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = gf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return kf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return le(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Pf = null;

const Tf = t => {
    Pf = t;
};

const qf = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t._(o));
    }
    return e;
};

const Af = t => {
    Pf = t.qt;
    const n = t.$;
    if (typeof Pf === "string") {
        if (!n) {
            throw Re(13);
        }
        const e = Ec;
        Pf = t.qt = qf(n, Pf);
        if (Ec !== e) {
            return Ec;
        }
    }
};

const Mf = (t, n) => {
    if (typeof n !== "function" || !t.qt) {
        return n;
    }
    return function e(...s) {
        Af(t);
        return n.apply(this, s);
    };
};

const xf = (t, n) => {
    const e = t.Ve;
    const s = typeof t.qt === "string";
    s && !t.$ && (t.$ = n || of()?.$);
    if (t.resolved) {
        return;
    }
    const o = Lf();
    const r = of();
    const i = e.We();
    const c = Rs(i, n => {
        t.resolved = Mf(t, n);
    });
    if (c) {
        const t = e.bt;
        Of(t, r?.m instanceof kr ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && Af(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const If = (t, n, e, s, o, r) => {
    const i = bf(t, n, s, e, r);
    const c = new Ef(i, o, r);
    return Nf(c);
};

const Nf = t => {
    const n = async function(...t) {
        return Sf.call(n, this, ...t);
    };
    n[_f] = t;
    Object.setPrototypeOf(n, Rf);
    return n;
};

const Cf = /*#__PURE__*/ new Set;

const Of = (t, n, e) => {
    if (!Cf.has(t)) {
        Cf.add(t);
        jf("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const jf = (t, n) => {
    qh() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Lf = () => {
    if (qh()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Ff = 0;

const Xf = t => If(null, "s" + Ff++, t, null, null);

const Df = Xf;

const Wf = t => t;

const Vf = t => If("", Pe, t, null, null);

const Uf = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return If("", Pe, t, null, null);
};

const zf = Symbol();

const Bf = "__qwik_component_registry__";

const Hf = t => {
    const n = t ? {
        id: "component:" + t.getHash(),
        qrlHash: t.getHash(),
        symbol: t.getSymbol()
    } : void 0;
    function e(e, s, o = 0) {
        const r = t.it.slice(0, 4);
        const i = r + ":" + (s || "");
        const c = () => {};
        c[Jf] = [ t ];
        if (n) {
            c[zf] = n;
            c[Bf] = n;
        }
        return Oi(c, e, null, e.children, o, i);
    }
    e[Jf] = [ t ];
    if (n) {
        e[zf] = n;
        e[Bf] = n;
    }
    return e;
};

const Jf = Symbol();

const Qf = t => typeof t == "function" && t[Jf] !== void 0;

const Yf = t => Hf(Df(t));

const Gf = oi(Wf);

const Kf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Zf = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !yr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Ze, "resumed");
    const s = te(t);
    s.Xt = e.serverData || {};
    const o = s.rootVNode;
    Jo(o, Mr, n);
    cn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            qt(s, [], s.rootVNode);
        }
    };
};

const ta = (t, n) => {
    const {val: e, set: s, iCtx: o} = $o();
    if (e != null) {
        return e;
    }
    const r = ke(t) ? oe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = mu(r, i, t);
        s(c);
        return c;
    }
};

const na = () => {
    const {val: t, set: n, iCtx: e} = $o();
    if (t != null) {
        return t;
    }
    const s = e.$.Pe || "";
    const o = s ? Cs(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, Ce);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Se;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.ke++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function fe(t, n) {
    const e = of();
    return e?.$?.Xt[t] ?? n;
}

const ea = /*#__PURE__*/ new Map;

const sa = (t, n) => {
    let e = ea.get(n);
    e || ea.set(n, e = ra(t, n));
    return e;
};

const ra = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = ca;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Oa) {
            r++;
            e = Ia;
        }
        const s = Ua[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === wa || $ === ba && ia(l) || $ === _a && ua(l)) && (y === e || y === wa || y === ba && ia(e) || y === va && !ia(e) && e !== qa || y === _a && ua(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === ya || m == ma) {
                    if (m === ma) {
                        if (c !== fa || h()) {
                            if (!oa(e)) {
                                const t = y == va ? 1 : y == Pa ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            oa(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === va) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || ca;
                        if (c === aa) {
                            u(r - 1);
                            i++;
                        }
                    } while (la(c));
                } else {
                    o.push(c);
                    if (c === aa && m === ca) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === ha && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === aa || h()) {
            return;
        }
        u(t);
        s.push(".", je, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ta) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ta) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | La) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(aa) !== -1 || o.indexOf(da) !== -1;
    }
};

const ia = t => t >= Aa && t <= Ma || t >= Ia && t <= Na || t >= Fa && t <= Xa || t >= 128 || t === ja || t === Ta;

const oa = t => t === xa || t === qa || t === Ca || t === Ra || ia(t);

const la = t => t === pa || t === da || t === $a || t === aa;

const ua = t => t === ka || t === ga || t === Ea || t === Sa;

const ca = 0;

const fa = 2;

const aa = 5;

const ha = 6;

const da = 10;

const pa = 11;

const $a = 12;

const ya = 17;

const ma = 18;

const wa = 0;

const ba = 1;

const va = 2;

const _a = 3;

const ga = 9;

const Ea = 10;

const Sa = 13;

const ka = 32;

const Ra = 35;

const Pa = 41;

const Ta = 45;

const qa = 46;

const Aa = 48;

const Ma = 57;

const xa = 58;

const Ia = 65;

const Na = 90;

const Ca = 91;

const Oa = 92;

const ja = 95;

const La = 32;

const Fa = 97;

const Xa = 122;

const Da = 123;

const Wa = 125;

const Va = /*@__PURE__*/ (() => [ [ wa, 39, 14 ], [ wa, 34, 15 ], [ wa, 47, 16, "*" ] ])();

const Ua = /*@__PURE__*/ (() => [ [ [ wa, 42, fa ], [ wa, Ca, 7 ], [ wa, xa, ha, ":", "before", "after", "first-letter", "first-line" ], [ wa, xa, aa, "global" ], [ wa, xa, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ wa, xa, 4 ], [ wa, ba, 1 ], [ wa, qa, 1 ], [ wa, Ra, 1 ], [ wa, 64, da, "keyframe" ], [ wa, 64, pa, "media", "supports", "container" ], [ wa, 64, $a ], [ wa, Da, 13 ], [ 47, 42, 16 ], [ wa, 59, ya ], [ wa, Wa, ya ], [ wa, Pa, ya ], ...Va ], [ [ wa, va, ma ] ], [ [ wa, va, ma ] ], [ [ wa, 40, ca ], [ wa, va, ma ] ], [ [ wa, 40, 8 ], [ wa, va, ma ] ], [ [ wa, 40, ca ], [ wa, va, ya ] ], [ [ wa, va, ya ] ], [ [ wa, 93, ma ], [ wa, 39, 14 ], [ wa, 34, 15 ] ], [ [ wa, Pa, ya ], ...Va ], [ [ wa, Wa, ya ], ...Va ], [ [ wa, Wa, ya ], [ _a, ba, 1 ], [ wa, xa, aa, "global" ], [ wa, Da, 13 ], ...Va ], [ [ wa, Da, ca ], [ wa, 59, ya ], ...Va ], [ [ wa, 59, ya ], [ wa, Da, 9 ], ...Va ], [ [ wa, Wa, ya ], [ wa, Da, 13 ], [ wa, 40, 8 ], ...Va ], [ [ wa, 39, ya ] ], [ [ wa, 34, ya ] ], [ [ 42, 47, ya ] ] ])();

const za = t => ({
    styleId: Qa(t, t => t, !1)
});

const Ba = /*#__PURE__*/ oi(za);

const Ha = t => ({
    scopeId: je + Qa(t, sa, !0)
});

const Ja = /*#__PURE__*/ oi(Ha);

const Qa = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = $o();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Cs(t.it)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Le(n(t, c), c, l, e));
    }
    r.$.Le(n(t.resolved, c), c, l, e);
    return c;
};

const Ya = (t, n) => {
    t.resolve();
    return ui(t, n);
};

const Ga = (t, n) => wo(Ya, t, n);

const Ka = oi(Ga);

const Za = t => {
    t.resolve();
    return fi(t);
};

const th = t => wo(Za, t);

const nh = oi(th);

const eh = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = $o();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !qh()) {
            e.h |= 32;
            sh(e, i);
        }
        return;
    }
    let c;
    if (qh()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        cn(r.$, r.m, 1);
    }
    const l = new Kl(c, o, r.m, t, void 0, null);
    s(l);
    sh(l, i);
};

const sh = (t, n) => {
    n === "intersection-observer" ? yc("qvisible", rh(t)) : n === "document-ready" ? mc("qinit", rh(t)) : n === "document-idle" && mc("qidle", rh(t));
};

const rh = t => If(null, "_task", En, null, [ t ]);

const ih = oi(dc);

const oh = /*#__PURE__*/ oi(Yl);

const lh = /*#__PURE__*/ oi(eh);

const uh = () => {
    const t = ta({
        error: void 0
    });
    Wc(zc, t);
    return t;
};

const ch = async ({track: t}) => {
    const n = Pf[0];
    t(() => n.items);
    const e = of();
    const s = e.m;
    const o = e.$;
    cn(o, s, 128);
    const r = he;
    r && await o.l;
};

const fh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Yl(/*#__PURE__*/ zu(ch, "_eaT", [ t ]));
    return Ji;
};

const ah = /*#__PURE__*/ Hf(
/*#__PURE__*/ zu(fh, "_eaC"));

const hh = /*#__PURE__*/ Dc("qk-reveal");

const dh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: ai(0)
});

const ph = () => {
    const t = Pf[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!de) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Ch(t);
};

const $h = ({cleanup: t}) => {
    const n = Pf[0];
    t(() => {
        if (!de) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const yh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = wo(dh, t);
    Wc(hh, n);
    const e = !de;
    if (__EXPERIMENTAL__.suspense && e && Fh()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!Fh()) {
                    return null;
                }
                const e = of()?.$;
                let s = 0;
                if (e) {
                    s = (Oh.get(e) || 0) + 1;
                    Oh.set(e, s);
                }
                return new jh(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = Lc(e);
            return e;
        })(n);
        /*#__PURE__*/
        return Ci(Dh, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return Ci(Hi, null, null, null, 0, "u7_0");
};

const mh = /*#__PURE__*/ Hf(
/*#__PURE__*/ zu(yh, "_reC"));

const Dh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Nh((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Ci(Hi, null, null, null, 0, "u7_0"));
}) : null;

const wh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Wh = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const bh = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const vh = ({track: t, cleanup: n}) => {
    const e = Pf[0], s = Pf[1], o = Pf[2], r = Pf[3];
    const i = t(e.pending);
    const c = de;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const _h = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = mo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return wo(bo);
    })();
    const s = (t => {
        const n = Vc(hh, null);
        const e = wo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Yl(/*#__PURE__*/ zu($h, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Ga(
    /*#__PURE__*/ zu(ph, "_reR", [ s ]));
    Yl(
    /*#__PURE__*/ zu(vh, "_suT", [ e, t, n, s ]));
    const r = !de;
    const i = r && Fh();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = of()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && zh(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ tc(wh, [ t, n, o, s ], Wh) : null;
    const d = /*#__PURE__*/ tc(bh, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ Ci(Vh, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, wi(t, "fallback"), 1, null) : /*#__PURE__*/ Ci("div", {
        style: tc(wh, [ t, n, o, s ], Wh)
    }, null, wi(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ Ci("div", null, i ? {
        [Th]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ Ci(i ? Uh : Hi, i ? {
        [ws]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [ws]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const gh = /*#__PURE__*/ Hf(
/*#__PURE__*/ zu(_h, "_suC"));

const Vh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Nh((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !zh(r) ? l.value = "fallback" : o && c && zh(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ Ci("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const Uh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Nh(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return Ci(Hi, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = M(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return Ci(Hi, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${Ph}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${Ph}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, i);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

function zh(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const Eh = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Sh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Ci("script", null, o, null, 0, "prefetch-service-worker");
};

const Sh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const kh = () => null;

globalThis.__qwik && Re(30, [ globalThis.__qwik, $r ]);

globalThis.__qwik = $r;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { Xf as $, ah as Each, Ui as Fragment, Fc as NoSerializeSymbol, kh as PrefetchGraph, Eh as PrefetchServiceWorker, zi as RenderOnce, pc as Resource, mh as Reveal, Yi as SSRComment, Qi as SSRRaw, Ki as SSRStream, Gi as SSRStreamBlock, Xc as SerializerSymbol, Ji as SkipRender, Hi as Slot, gh as Suspense, Ur as _CONST_PROPS, ef as _DomContainer, mr as _EFFECT_BACK_REF, Yr as _EMPTY_ARRAY, Gr as _EMPTY_OBJ, Jr as _IMMUTABLE, nc as _SharedContainer, gi as _SubscriptionData, Eu as _SubscriptionPatch, Qr as _UNINITIALIZED, zr as _VAR_PROPS, Wn as _addProjection, Pf as _captures, v as _chk, Kn as _createDeserializeContainer, If as _createQRL, Yn as _deserialize, Lu as _dumpState, fh as _eaC, ch as _eaT, ln as _executeSsrChores, tc as _fnSignal, Zu as _getAsyncLocalStorage, ri as _getConstProps, yf as _getContextContainer, $f as _getContextEvent, pf as _getContextHostElement, te as _getDomContainer, ee as _getQContainerElement, si as _getVarProps, pu as _hasStoreEffects, _c as _hmr, Ri as _isJSXNode, yu as _isStore, Cn as _isStringifiable, Zl as _isTask, mf as _jsxBranch, ji as _jsxC, Fi as _jsxQ, Li as _jsxS, Ci as _jsxSorted, Oi as _jsxSplit, me as _mapApp_findIndx, be as _mapArray_get, we as _mapArray_set, Bu as _noopQrl, Hu as _noopQrlDEV, In as _preprocessState, Uf as _qrlSync, qn as _qrlToString, Ju as _qrlWithChunk, Qu as _qrlWithChunkDEV, yh as _reC, ph as _reR, $h as _reT, Ku as _regSymbol, zn as _removeProjection, _ as _res, Uc as _resolveContextWithoutSequentialScope, so as _restProps, hc as _rsc, F as _run, Qn as _serialize, Fn as _setEvent, Vn as _setProjectionTarget, _h as _suC, vh as _suT, En as _task, oc as _uas, Un as _updateProjectionProps, Dn as _useHmr, b as _val, Ic as _verifySerializable, Go as _vnode_ensureElementInflated, Xl as _vnode_getAttrKeys, bl as _vnode_getElementName, gl as _vnode_getFirstChild, Ho as _vnode_getProp, rl as _vnode_getVNodeForChildNode, pl as _vnode_insertBefore, Do as _vnode_isElementVNode, Vo as _vnode_isMaterialized, Uo as _vnode_isTextVNode, zo as _vnode_isVirtualVNode, Fo as _vnode_newVirtual, ml as _vnode_remove, Jo as _vnode_setProp, yn as _vnode_toString, wf as _waitUntilRendered, jn as _walkJSX, wi as _wrapProp, vi as _wrapSignal, Yf as component$, Hf as componentQrl, di as createAsync$, ci as createAsyncQrl, hi as createComputed$, ui as createComputedQrl, Dc as createContextId, g as createElement, pi as createSerializer$, fi as createSerializerQrl, ai as createSignal, Gf as event$, Wf as eventQrl, du as forceStoreEffects, Kf as getClientManifest, te as getDomContainer, re as getLocale, Us as getPlatform, g as h, oi as implicit$FirstArg, zu as inlinedQrl, Gu as inlinedQrlDEV, pe as isDev, nu as isSignal, Di as jsx, Wi as jsxDEV, Vi as jsxs, Lc as noSerialize, Uu as qrl, Yu as qrlDEV, Zf as render, Vs as setPlatform, Vf as sync$, ff as untrack, $u as unwrapStore, uc as useAsync$, lc as useAsyncQrl, Ka as useComputed$, Ga as useComputedQrl, wo as useConstant, Vc as useContext, Wc as useContextProvider, uh as useErrorBoundary, na as useId, ac as useLexicalScope, yc as useOn, mc as useOnDocument, wc as useOnWindow, ih as useResource$, dc as useResourceQrl, nh as useSerializer$, th as useSerializerQrl, fe as useServerData, mo as useSignal, ta as useStore, Ba as useStyles$, za as useStylesQrl, Ja as useStylesScoped$, Ha as useStylesScopedQrl, oh as useTask$, Yl as useTaskQrl, lh as useVisibleTask$, eh as useVisibleTaskQrl, $r as version, ie as withLocale };
